import { DatePipe } from '@angular/common';
import { Component, ElementRef, HostListener, OnInit, ViewChild } from '@angular/core';
import { AnalyzeService } from 'src/app/appServices/AnalyzeService/analyzeService.service';
import * as FileSaver from 'file-saver'; // FOR SAVING EXCEL FILE
import ChartDataLabels from 'chartjs-plugin-datalabels';
import { drawDOM, exportPDF, Group, } from "@progress/kendo-drawing";
import { saveAs } from "@progress/kendo-file-saver";
import { Workbook } from 'exceljs';
import { HelperService } from 'src/app/appServices/HelperService/helper.service';
import { LocalStorage} from 'src/app/appCommon/Enums/enum';
import { MessageService } from 'primeng/api';
import { ToasterService } from 'src/app/appServices/ToasterService/toaster.service';
import { AxisLabelContentArgs, LegendLabelsContentArgs, LineStyle, SeriesLabels, SeriesLabelsContentArgs, SeriesLabelsVisualArgs, ValueAxisLabels } from '@progress/kendo-angular-charts';
import { ObservableService } from 'src/app/appServices/ObservableService/observable.service';
import { ByFacilityParticipatesPIReporting, preArivalOptions, selectActiveOptions, selectReportTypeOptions, selectWorkFlowTypeOptions, selectedFacilityOptions, spokeSiteOpions, workFlow_typeOptions } from 'src/app/appWeb/shared/shared';
import { ImproveService } from 'src/app/appServices/ImproveService/improve.service';
import { AuthService } from 'src/app/appServices/AuthService/auth.service';

@Component({
  selector: 'app-facility-pi',
  templateUrl: './facility-pi.component.html',
  styleUrls: ['./facility-pi.component.scss'],
})
export class FacilityPIComponent implements OnInit {
  @ViewChild('htmlData') htmlData: any = ElementRef;
  public lineChartPlugins = [ChartDataLabels];

  Ten_Min_or_Less_Activation_EMS_PV_Chart_Data: any;

  showAllChartBool = false;
  pi_chartBool: any = { 'value': false };
  chartDatasets: any = [];
  barChartDatasets: any = [];
  doortostarttitle: any;
  doortostartmean: any;
  doortostartmedian: any;
  doortostartmeancal: any = [];
  doortostartmediancal: any = [];
  doortostartcatgory: any;
  minDoortostartVal: any;
  maxDoortostartVal: any;

  activationemsmeancal:any = [];
  activationemscatgory: any;
  activationpvmeancal:any = [];

  starttoresponsetitle: any;
  starttoresponsemean: any;
  starttoresponsemeancal: any = [];
  starttoresponsecatgory: any;
  minStarttoresponseVal: any;
  maxStarttoresponseVal: any;
  starttoresponsemedian: any;
  starttoresponsemediancal: any = [];

  alteplaseadmintitle: any;
  alteplaseadminmean: any;
  alteplaseadminmeancal: any = [];
  alteplaseadmincatgory: any;

  doortoneedletitle: any;
  doortoneedlemean: any;
  doortoneedlemeancal: any = [];
  doortoneedlecatgory: any;
  minDoortoneedleVal: any;
  maxDoortoneedleVal: any;
  doortoneedlemedian: any;
  doortoneedlemediancal: any = [];

  activitationtoneedletitle: any;
  activitationtoneedlemean: any;
  activitationtoneedlemeancal: any = [];
  activitationtoneedlecatgory: any;
  activitationtoneedlemedian: any;
  activitationtoneedlemediancal: any = [];
  minActivitationtoneedleVal: any;
  maxActivitationtoneedleVal: any;

  DTN30percentmean: any;
  DTN30percentmeancal: any = [];
  DTN30percentcatgory: any;
  DTN45percentmeancal: any = [];
  DTN60percentmeancal: any = [];

  ActivationtoAssessmenttitle: any;
  ActivationtoAssessmentmean: any;
  ActivationtoAssessmentmedian: any;
  ActivationtoAssessmentmeancal: any = [];
  ActivationtoAssessmentmediancal: any = [];
  ActivationtoAssessmentcatgory: any;
  minActivationtoAssessmentVal: any;
  maxActivationtoAssessmentVal: any;

  AssessmenttoThrombolytictitle: any;
  AssessmenttoThrombolyticmedian: any;
  AssessmenttoThrombolyticmean: any;
  AssessmenttoThrombolyticmediancal: any = [];
  AssessmenttoThrombolyticmeancal: any = [];
  AssessmenttoThrombolyticcatgory: any;
  minAssessmenttoThrombolyticval: any;
  maxAssessmenttoThrombolyticval: any;


  ThrombolytictoThrombolyticadministrationtitle: any;
  ThrombolytictoThrombolyticadministrationavg: any;
  ThrombolytictoThrombolyticadministrationmedian: any;
  ThrombolytictoThrombolyticadministrationmeancal: any = [];
  ThrombolytictoThrombolyticadministrationmediancal: any = [];
  ThrombolytictoThrombolyticadministrationcatgory: any;
  minThrombolytictoThrombolyticadministrationVal: any;
  maxThrombolytictoThrombolyticadministrationVal: any;


  doortonircallbacktitle: any;
  doortonircallbackmean: any;
  doortonircallbackmedian: any;
  doortonircallbackmeancal: any = [];
  doortonircallbackmediancal: any = [];
  doortonircallbackcatgory: any;
  chartFoundBool: boolean = false;
  screenWidth: number = 0;
  public seriesLabels: SeriesLabels = {
    visible: true, // Note that visible defaults to false
    padding: 3,
    font: "bold 16px Arial, sans-serif",
  };
  public titleAlignment: any = {
    align: 'start'
  };
  public valueAxisLabels: ValueAxisLabels = {
    font: "bold 14px Arial, sans-serif",
    color:"#000000",
    // format: 'N0'
  };
public style: LineStyle = "smooth";

  public series: any = {
    color: '#ed2078',
    colorLabel:'#ed2078',
    font: "bold 11px Arial, sans-serif",
    padding:{bottom:10}
  };
  public seriesWidth: any = {
    font: "bold 8px Arial, sans-serif"
  };
  public labelWidthGreater: any = {
    font: "bold 20px Arial, sans-serif"
  };
  public seriesMedian: any = {
    color: '#36286b',
    colorLabel:'#36286b',
    font: "bold 14px Arial, sans-serif"
  };

  public seriesdtn60: any = {
    color: '#3B82F6',
    colorLabel:'#3B82F6',
    font: "bold 14px Arial, sans-serif"
  };
  
  flag = 0;

  loading = [false, false, false, false];
  selectedFacilityOptions = selectedFacilityOptions;
  selectReportTypeOptions = selectReportTypeOptions;
  selectActiveOptions = selectActiveOptions;
  spokeSiteOpions = spokeSiteOpions;
  preArivalOptions = preArivalOptions;
  workFlow_typeOptions = workFlow_typeOptions;
  selectWorkFlowTypeOptions = selectWorkFlowTypeOptions;
  facility: any = '';
  reportType = '';
  spokeSite: any = '';
  pre_arival: any = '';
  work_flow_rapid: any = '';
  fromDays: any = '';
  toDays: any = '';
  reportTypeBool: boolean = false;
  fromDaysToDaysBool: boolean = false;
  selectWeekBool: boolean = false;
  active = '';

  fromMonth: any = '';
  toMonth: any = '';
  fromMonthAndComulative: any = '';
  toMonthAndComulative: any = '';

  monthBool: boolean = false;
  activeOptionsBool: boolean = true;
  spokeSiteBool: boolean = false;
  pre_ArrivalBool: boolean = false;
  week: any = '';

  pageNumber = 1;
  rows = 10;
  sortOrder = 'Asc';
  sortCol = '';
  filterVal = '';
  allChartBool: boolean = false;
  FilterList: any;
  SelectListFilter: any = [];
  selectFacilityPIOptions: any = '';
  selectFacilityPIOptionsBool: boolean = false;
  ByFacilityParticipatesPIReporting = ByFacilityParticipatesPIReporting;
  datePipe = new DatePipe('en-US');
  event: any = '';
  Facilities: any = null;
  System: any = null;
  Regional: any = null;
  States: any = null;
  QPS: any = null;
  ByPIFacility: any;
  piCharVisibility: any;
  filter_option: any;
  /* RAPIDi Notification */
  rAPIDiNotificationBool: boolean = false;
  selctReportOption: any;

  /* TPA Case Analysis */
  tPACaseAnalysisBool: boolean = false;

  /* PI Trends */
  selectedFacilitybtnBool: boolean = true;
  pITrendsBool: boolean = false;
  workFlowRapidTypeBool: boolean = false;
  workFlowPiTrendTypeBool: boolean = false;
  work_flow_piTrend: any = [];
  facilitySelectedTab = 'Facility Dashboard';
  FileSaver = FileSaver;
  allChartsData: any = [];
  onClickDisable = { 'value': true }
  FacilityDashboardLoader: boolean = false;
  loader: any;
  exportPdfFacilityDashboardLoader: boolean = false;
  exportExcelLoader: boolean = false;
  piChartLoader: boolean = false;
  onClickSearchBtnDisable: boolean = true;
  facilityQPSLbl: any;
  excelFileByTab: any;
  excel_chartDisabe: any = { 'value': true, 'facility_charts_Show': true, 'excel_show': true, 'pi_chart_show': false };
  facility_Pi_Show: any = { 'fac_Dashboard_Show': false, 'rapidi_Noti_Show': false, 'thrym_Cas_Ana_Show': false, 'pi_Trend_Show': false, 'counter_measure_Show': false, 'volumetric_Show': false, 'strokeAlert_Cases_Show': false };
  btnClicked: any = 1;
  RoleName: any;
  tempSelectReportOption: any;
  UId: any;
  filterType!: boolean;
  reportTypeError!: boolean;
  fromMonthErrorBool!: boolean;
  fromDateErrorBool!: boolean;
  toDateErrorBool!: boolean;
  toMonthErrorBool!: boolean;
  weekErrorBool!: boolean;
  fromToMonthErrorBool: boolean = false;
  fromToDateErrorBool: boolean = false;
  workFlowTypeRAPIDiBool: boolean = false;
  workFlowTypePITrendBool: boolean = false;
  workFlowTypeColorBool: boolean = false;
  bool: boolean = false;

  /*for excel variables start*/
  activationTimeList:any= [];
  assessmentTimeList:any = [];
  thrombolyticDecisionTimeList:any = [];
  thrombolyticAdministrationTimeList:any = [];

  tPACaseAnalysisList:any = [];

  counterMeasuresData:any = [];
  proposed_date_array:any = [];
  showProgressSpinner: boolean = false;
  minDoortonircallbackVal: any;
  facilityDasboardReplica: any = [];
  /*for excel variables end*/

  selectedDateVolumetric: any = [];
  firstMonthDateVolumetric: any = [];
  selectedDateStrokeAlert: any = [];
  TotaAllCasesSelectedVolimatric: any;
  pieDataSelectedVolimatric: any;
  TotaAllSelectedDateStrokeAlert: any;
  pieDataSelectedDateStrokeAlert: any;
  selectedDateVolumetricBool: boolean = false;
  selectedDateStrokeAlertBool: boolean = false;
  firstMonthDateVolumetricBool: boolean = false;
  minDateSelectedVolumetric: any = '';
  maxDateSelectedVolumetric: any = '';
  minDateFirstMonthVolumetric: any = '';
  maxDateFirstMonthVolumetric: any = '';
  minDateSelectedStrokeAlert: any = '';
  maxDateSelectedStrokeAlert: any = '';
  TotaAllFirstMonthDateVolumetric: any;
  SelectFacilityData:any=[];
  SelectSystemData:any=[];
  subscription: any=[];
  SelectRegionalData: any=[];
  SelectQpsData: any=[];
  SelectStateData: any=[];
  SelectPiData: any=[];
  facilityLabels = ['Facility', 'System', 'Region', 'State', 'QPS', 'Filter Type'];
  roleForFacility: boolean = false;


  constructor(private analyzeService: AnalyzeService,private helperService: HelperService,private improveService: ImproveService,
    private messageService: MessageService,private toastService: ToasterService,private Observable:ObservableService,private authService: AuthService) {
    this.work_flow_piTrend = this.selectWorkFlowTypeOptions.map((option:any) => option.Value);
    this.loader = { 'value': false }
  }

  ngOnInit(): void {
    this.UId = this.helperService.decryption(localStorage.getItem(LocalStorage.UId));
    this.RoleName = this.helperService.decryption(localStorage.getItem(LocalStorage.UserRoleName));
    this.analyzeService._facilityPiComponent.FacilityPIComponent = this;
    this.roleForFacility = this.authService.roleForFacility();

    // this.getAllValuesOfFilter();
    this.loader.value = false;
    this.screenWidth = window.innerWidth;
  }

  @HostListener('window:resize', ['$event']) onResize(event:any) {
    this.screenWidth = window.innerWidth;
  }
   
  onChangeReportType(event: any) {
    this.selctReportOption = event.value;
    this.tempSelectReportOption = event.value;
    if (event.value == this.selectReportTypeOptions[1].value) {
      this.fromDaysToDaysBool = true;
      this.fromToMonthErrorBool = false;
    } else {
      this.fromDaysToDaysBool = false;
      this.fromDays = null;
      this.toDays = null;
    }
    if (event.value == this.selectReportTypeOptions[2].value) {
      this.selectWeekBool = true;
      this.fromToMonthErrorBool = false;
    } else {
      this.selectWeekBool = false;
      this.week = null;
    }
    if (
      event.value == this.selectReportTypeOptions[3].value ||
      event.value == this.selectReportTypeOptions[4].value
    ) {
      this.monthBool = true;
      this.fromToMonthErrorBool = false;
    } else {
      this.monthBool = false;
      this.fromMonth = null;
      this.toMonth = null;
      this.fromMonthAndComulative = null;
      this.toMonthAndComulative = null;
    }
    this.onClickSearchBtnDisable = false;
  }

  getStyle(labelIndex: number) {
    return this.filterType && this.facilityQPSLbl === labelIndex ? { 'color': 'red', 'font-size': '15px' } : { 'color': 'black' };
  }

  onChangeFilterType(event: any) {
    this.event = event.value;
    
    if (event.value == this.selectedFacilityOptions[0].value) {
      this.selectFacilityPIOptionsBool = false;
      this.activeOptionsBool = true;
      this.spokeSiteBool = false;
    }else if (event.value == this.selectedFacilityOptions[1].value) {
      if(this.SelectFacilityData.length>0){
        
        this.SelectListFilter = this.SelectFacilityData;
      }else{
        this.SelectListFilter = '';
        this.GetAllData('facility');
      }
      this.selectFacilityPIOptionsBool = true;
      this.activeOptionsBool = true;
      this.spokeSiteBool = false;
      this.facilityQPSLbl = 1;  
    }else if (event.value == this.selectedFacilityOptions[2].value) {
      if(this.SelectSystemData.length>0){
        this.SelectListFilter = this.SelectSystemData;
      }else{
        this.SelectListFilter = '';
        this.GetAllData('system');
      }
      this.selectFacilityPIOptionsBool = true;
      this.activeOptionsBool = false;
      if(this.selectedFacilitybtnBool == true) {
        this.spokeSiteBool = true;
      }
      this.facilityQPSLbl = 2;
    }else if (event.value == this.selectedFacilityOptions[3].value) {
      if(this.SelectRegionalData.length>0){
        this.SelectListFilter = this.SelectRegionalData;
      }else{
        this.SelectListFilter = '';
        this.GetAllData('regional');
      }
      this.selectFacilityPIOptionsBool = true;
      this.activeOptionsBool = false;
      if(this.selectedFacilitybtnBool == true) {
        this.spokeSiteBool = true;
      }
      this.facilityQPSLbl = 3;
      
    }else if (event.value == this.selectedFacilityOptions[4].value) {
      if(this.SelectStateData.length>0){
        this.SelectListFilter = this.SelectStateData;
      }else{
        this.SelectListFilter = '';
        this.GetAllData('state');
      }
      this.selectFacilityPIOptionsBool = true;
      this.activeOptionsBool = false;
     if (this.selectedFacilitybtnBool == true && this.event !== 'state' ) {
        this.spokeSiteBool = true;
      }else{
        this.spokeSiteBool = false;
      }
      this.facilityQPSLbl = 4;
    }else if (event.value == this.selectedFacilityOptions[5].value) {
      if(this.SelectQpsData.length>0){
        this.SelectListFilter = this.SelectQpsData;
      }else{
        this.SelectListFilter = '';
        this.GetAllData('qps');
      }
      this.selectFacilityPIOptionsBool = true;
      this.activeOptionsBool = false;
      this.spokeSiteBool = false;
      this.facilityQPSLbl = 5;
    }else  if (event.value == this.selectedFacilityOptions[6].value) {
      this.SelectListFilter = '';
      this.SelectListFilter = this.ByFacilityParticipatesPIReporting;
      this.selectFacilityPIOptionsBool = true;
      this.activeOptionsBool = false;
      this.spokeSiteBool = false;
      this.facilityQPSLbl = 6;
     
    }
   
  }
  CheckDaysDate(event: any) {
    if (this.fromMonth && this.toMonth) {
      if (this.fromMonth.getFullYear() === this.toMonth.getFullYear() &&
          this.fromMonth.getMonth() === this.toMonth.getMonth()) {
        return;
      }
      const lastDayOfMonth = new Date(this.fromMonth.getFullYear(), this.fromMonth.getMonth() + 1, 0);
      this.toMonth = lastDayOfMonth;

      this.messageService.add({
        key: 'save',
        severity: 'error',
        summary: 'Invalid date range',
        detail: 'Please select a date within the same month and year as the start date.',
      });
    }
  }
  // getAllValuesOfFilter() {
  //   this.analyzeService.GetFacilityPIList(this.RoleName, this.UId).subscribe({
  //     next: (res: any) => {
  //       if (res) {
  //         let filter = { value: this.event };
  //         this.FilterList = res;
  //         this.onChangeFilterType(filter);
  //       }
  //     },
  //     error: (err: any) => { },
  //   });
  // }

  GetAllData(req:any) {
    if ( this.SelectFacilityData.length==0 && req == 'facility'  || this.SelectSystemData.length==0 && req == 'system' 
    || this.SelectRegionalData.length==0 && req == 'regional' || this.SelectStateData.length==0 && req == 'state' 
    || this.SelectQpsData.length==0 && req == 'qps' || this.SelectPiData.length==0 && req == 'pi'){
      this.showProgressSpinner=true
  let obj: any = {};
  switch (req) {
    case 'facility':
      obj.fieldName = 'facility';
      obj.value = 'facility';
      break;
    case 'system':
      obj.fieldName = 'ucd_ucl_key';
      obj.value = '42';
      break;
    case 'regional':
      obj.fieldName = 'ucd_ucl_key';
      obj.value = '43';
      break;
    case 'state':
      obj.fieldName = 'ucd_ucl_key';
      obj.value = '21';
      break;
    case 'qps':
      obj.fieldName = 'qps';
      obj.value = 'qps';
      break;
    default:
      obj.fieldName = 'ucd_ucl_key';
      obj.value = '42';
      break;
  }
      this.analyzeService.GetAllData(obj,this.RoleName, this.UId).subscribe({
        next: (res: any) => {
          if (res) {
            this.showProgressSpinner = false;            
            switch (req) {
              case 'facility':
                this.SelectFacilityData = res.data;
                break;
              case 'system':
                this.SelectSystemData = res.data;
                break;
              case 'regional':
                this.SelectRegionalData = res.data;
                break;
              case 'state':
                this.SelectStateData = res.data;
                break;
              case 'qps':
                this.SelectQpsData = res.data;
                break;
              case 'pi':
                this.SelectPiData = res.data;
                break;
              default:
                break;
            }
            this.SelectListFilter = res.data;
          }
        },
        error: (err: any) => { },
      })
  }
  }
  

  enableSearch(event:any){
    this.onClickSearchBtnDisable = false;
  }
  getFacilityDashboardValues() {
    var Year:any;
    if(this.selctReportOption == ''){
      this.selctReportOption = this.tempSelectReportOption;
    }
    if(this.fromMonthAndComulative != null && this.fromMonthAndComulative != '' && this.selctReportOption == 'monthly' || 
    this.fromMonthAndComulative != null && this.fromMonthAndComulative != '' && this.selctReportOption == 'cumulative'){
      Year = (this.fromMonthAndComulative).getFullYear();
   }
   if(this.fromMonth != "" && this.selctReportOption == 'daily' && this.fromMonth != null ||
    this.fromMonth != "" && this.selctReportOption == 'weekly' && this.fromMonth != null){
      Year = (this.fromMonth).getFullYear();
   }
    if (
      this.facilitySelectedTab == 'Facility Dashboard' && this.selctReportOption == 'monthly' ||
      this.facilitySelectedTab == 'Facility Dashboard' && this.selctReportOption == 'cumulative' ||
      this.facilitySelectedTab == 'RAPIDi Notification' && this.selctReportOption == 'monthly' ||
      this.facilitySelectedTab == 'RAPIDi Notification' && this.selctReportOption == 'cumulative'||
      this.facilitySelectedTab == 'Counter Measures' && this.selctReportOption == 'monthly' ||
      this.facilitySelectedTab == 'Counter Measures' && this.selctReportOption == 'cumulative'||
      this.facilitySelectedTab == 'Volumetrics' && this.selctReportOption == 'monthly'||
      this.facilitySelectedTab == 'Volumetrics' && this.selctReportOption == 'cumulative'||
      this.facilitySelectedTab == 'TPA Case Analysis' && this.selctReportOption == 'monthly'||
      this.facilitySelectedTab == 'TPA Case Analysis' && this.selctReportOption == 'cumulative'||
      this.facilitySelectedTab == 'PI Trends' && this.selctReportOption == 'monthly'||
      this.facilitySelectedTab == 'PI Trends' && this.selctReportOption == 'cumulative'||
      this.facilitySelectedTab == 'Stroke Alert Cases' && this.selctReportOption == 'monthly'||
      this.facilitySelectedTab == 'Stroke Alert Cases'&& this.selctReportOption == 'cumulative'
    ) {
      this.fromMonth = this.datePipe.transform(this.fromMonthAndComulative, 'MM/dd/yyyy');
      this.toMonth = this.datePipe.transform(this.toMonthAndComulative, 'MM/dd/yyyy');
    }
    
    if(this.selctReportOption == 'daily'){
      if(this.fromMonth != null && this.toMonth != null){
        var fromYear = (this.fromMonth).getFullYear();
        var toYear = (this.toMonth).getFullYear();
      }

      this.fromMonth = this.datePipe.transform(this.fromMonth, 'MM/dd/yyyy');
      this.toMonth = this.datePipe.transform(this.toMonth, 'MM/dd/yyyy');
      
      if(this.fromMonth > this.toMonth || fromYear > toYear){
        this.fromToDateErrorBool = true;
      }else{
        this.fromToDateErrorBool = false;
      }
    }
    const newLocal = this;
    this.fromMonth = this.datePipe.transform(this.fromMonth, 'MM/dd/yyyy');
    this.toMonth = this.datePipe.transform(this.toMonth, 'MM/dd/yyyy');
    this.nullValues();
    if (this.selctReportOption == this.selectReportTypeOptions[2].value) {
      this.toMonth = this.fromMonth;
    }
     if (this.selctReportOption == this.selectReportTypeOptions[3].value ||
      this.selctReportOption == this.selectReportTypeOptions[4].value) {
      this.fromMonth = this.datePipe.transform(this.fromMonthAndComulative, 'MM/dd/yyyy');
      this.toMonth = this.datePipe.transform(this.toMonthAndComulative, 'MM/dd/yyyy');
      if(this.fromMonthAndComulative > this.toMonthAndComulative){
        this.fromToMonthErrorBool = true;
      }else{
        this.fromToMonthErrorBool = false;
      }
      this.fromToDateErrorBool = false;
    }
    if(this.work_flow_piTrend == "" && this.facilitySelectedTab == 'RAPIDi Notification'){
      this.workFlowTypeRAPIDiBool = true;
    }else{
      this.workFlowTypeRAPIDiBool = false;
    }

    if(this.work_flow_piTrend == "" && this.facilitySelectedTab == 'PI Trends'){
      this.workFlowTypePITrendBool = true;
    }else{
      this.workFlowTypePITrendBool = false;
    }
    if (this.event == this.selectedFacilityOptions[1].value) {
      this.Facilities.push(this.selectFacilityPIOptions);
    } 
    if (this.event == this.selectedFacilityOptions[2].value) {
      this.System.push(Number(this.selectFacilityPIOptions));
    }  
    if (this.event == this.selectedFacilityOptions[3].value) {
      this.Regional.push(Number(this.selectFacilityPIOptions));
    } 
     if (this.event == this.selectedFacilityOptions[4].value) {
      this.States.push(Number(this.selectFacilityPIOptions));
    }
     if (this.event == this.selectedFacilityOptions[5].value) {
      this.QPS.push(this.selectFacilityPIOptions);
    }
      if (this.event == this.selectedFacilityOptions[6].value) {
      this.ByPIFacility = this.selectFacilityPIOptions;
    }  
    if(this.selectFacilityPIOptions != "" && this.selectFacilityPIOptions != null && this.fromMonth != null && this.toMonth != null && this.selctReportOption == 'daily' && this.fromToMonthErrorBool != true && this.fromToDateErrorBool != true && this.workFlowTypeRAPIDiBool != true && this.workFlowTypePITrendBool != true ||
    this.selectFacilityPIOptions != "" && this.selectFacilityPIOptions != null && this.fromMonth != null && this.toMonth != null && this.selctReportOption == 'monthly' && this.fromToMonthErrorBool != true && this.fromToDateErrorBool != true && this.workFlowTypeRAPIDiBool != true && this.workFlowTypePITrendBool != true ||
    this.selectFacilityPIOptions != "" && this.selectFacilityPIOptions != null && this.fromMonth != null && this.toMonth != null && this.selctReportOption == 'cumulative' && this.fromToMonthErrorBool != true && this.fromToDateErrorBool != true && this.workFlowTypeRAPIDiBool != true && this.workFlowTypePITrendBool != true ||
    this.selectFacilityPIOptions != "" && this.selectFacilityPIOptions != null && this.fromMonth != null && this.selctReportOption == 'weekly' && this.fromToMonthErrorBool != true  && this.fromToDateErrorBool != true && this.workFlowTypeRAPIDiBool != true && this.workFlowTypePITrendBool != true ||
    this.reportType != "" && this.selectFacilityPIOptions != "" && this.selectFacilityPIOptions != null && this.fromMonth != null && this.toMonth != null && this.selctReportOption == 'monthly' && this.fromToMonthErrorBool != true && this.fromToDateErrorBool != true && this.workFlowTypeRAPIDiBool != true && this.workFlowTypePITrendBool != true ){
    let data = {
      Take: this.rows,
      Skip: this.rows * this.pageNumber - this.rows,
      Sort: {
        FieldName: this.sortCol,
        Order: this.sortOrder,
      },
      Filter: {
        field: '',
        operator: '',
        value: this.filterVal,
        logic: '',
        filters: [],
      },
      searchString: this.filterVal,
      PageNumber: this.pageNumber,
      serviceType: [],
      data: {
        Facilities: this.Facilities,
        System: this.System,
        Regional: this.Regional,
        States: this.States,
        QPS: this.QPS,
        ByPIFacility: this.ByPIFacility,
        fromMonth: this.fromMonth,
        toMonth: this.toMonth,
        QualityGoalsData: null,
        ReportType: this.reportType,
        PatientType: this.work_flow_piTrend,
        ActiveNonActiveFacility: this.active,
        FilterType: this.facility,
        qag_time_frame: `${Year}-1-1`,
        Status: this.analyzeService._statusValue,
        SpokeSiteFilter: this.spokeSite,
        PreArrival: Number(this.pre_arival)
      },
        showChartBool:false
    };
      this.analyzeService._facilityPiFilterObj.FacilityDashboardDataObj = data;
      this.analyzeService._facilityPiFilterObj.RapidiNotificationDataObj = data;
      this.analyzeService._facilityPiFilterObj.TpaCaseAnalysisDataObj = data;
      this.analyzeService._facilityPiFilterObj.PiTrendsDataObj = data;
      this.analyzeService._facilityPiFilterObj.CounterMeasuresDataObj = data;
      this.analyzeService._facilityPiFilterObj.VolumetricsDataObj = data;
      this.analyzeService._facilityPiFilterObj.StrokeAlertCasesDataObj = data;
    if (this.facilitySelectedTab == 'Facility Dashboard') {
      this.loader.value = true;
      this.excel_chartDisabe.value = true;
      this.facility_Pi_Show.fac_Dashboard_Show = true;
      this.analyzeService._facilityPiFilterObj.FacilityDashboardDataObj = data;
      this.filter_option = this.event;
      this.analyzeService._facilityPiComponent.FacilityDashboardComponent.getFacilityDashboardValues(newLocal.onClickDisable, this.excel_chartDisabe, this.event, this.loader);
    }
    if (this.facilitySelectedTab == 'RAPIDi Notification') {
      this.loader.value = true;
      this.facility_Pi_Show.rapidi_Noti_Show = true;
      this.analyzeService._facilityPiFilterObj.RapidiNotificationDataObj = data;
      this.analyzeService._facilityPiComponent.RapidiNotificationComponent.SelectedTabCall(this.excel_chartDisabe, this.loader);
    }
    if (this.facilitySelectedTab == 'TPA Case Analysis') {
      this.loader.value = true;
      this.facility_Pi_Show.thrym_Cas_Ana_Show = true;
      this.analyzeService._facilityPiFilterObj.TpaCaseAnalysisDataObj = data;
      this.analyzeService._facilityPiComponent.TpaCaseAnalysisComponent.getTPACaseAnalysisValues(this.excel_chartDisabe, this.loader);
    }
    if (this.facilitySelectedTab == 'PI Trends') {
      this.loader.value = true;
      this.facility_Pi_Show.pi_Trend_Show = true;
      this.analyzeService._facilityPiFilterObj.PiTrendsDataObj = data;
      this.analyzeService._facilityPiComponent.PiTrendsComponent.GetRootCauseTrends(this.excel_chartDisabe, this.loader);
    }
    if (this.facilitySelectedTab == 'Counter Measures') {
      this.loader.value = true;
      this.analyzeService._facilityPiFilterObj.CounterMeasuresDataObj = data;
      this.analyzeService._facilityPiComponent.CounterMeasuresComponent.GetCounterMeasures(this.excel_chartDisabe,this.loader);
    }
    if (this.facilitySelectedTab == 'Volumetrics') {
      this.loader.value = true;
      this.facility_Pi_Show.volumetric_Show = true;
      this.analyzeService._facilityPiFilterObj.VolumetricsDataObj = data;
      this.analyzeService._facilityPiComponent.VolumetricsComponent.GetVolumetricsCases(this.excel_chartDisabe, this.loader);
    }
    if (this.facilitySelectedTab == 'Stroke Alert Cases') {
      this.loader.value = true;
      this.facility_Pi_Show.strokeAlert_Cases_Show = true;
      this.analyzeService._facilityPiFilterObj.StrokeAlertCasesDataObj = data;
      this.analyzeService._facilityPiComponent.StrokeAlertCasesComponent.GetStrokeAlertCases(this.excel_chartDisabe, this.loader);
    }
    if (this.selctReportOption == this.selectReportTypeOptions[1].value ||
      this.selctReportOption == this.selectReportTypeOptions[2].value ||
      this.selctReportOption == this.selectReportTypeOptions[3].value) {
      this.toMonth = new Date(this.toMonth);
      this.fromMonth = new Date(this.fromMonth);
    }
    this.loader.value = false;
  }else{
    if(this.selectFacilityPIOptions == "" || this.selectFacilityPIOptions == null){
      let name:any;
      if(this.facilityQPSLbl == 1){
       name = 'Facility';
      }else if(this.facilityQPSLbl == 2){
        name = 'System';
       }else if(this.facilityQPSLbl == 3){
        name = 'Region';
       }else if(this.facilityQPSLbl == 4){
        name = 'State';
       }else if(this.facilityQPSLbl == 5){
        name = 'QPS';
       }else if(this.facilityQPSLbl == 6){
        name = 'Filter Type';
       }else{
        name = 'Related';
       }
    this.messageService.add({
      key: 'save',
      severity: 'error',
      summary: 'Please ',
      detail: `Please select FILTER TYPE first and ${name} field.`,
    });
    
    this.filterType = true;
    setTimeout(() => {
      this.filterType = false;
    }, 1000);
    this.DateFormate();
    return;
    
  }
  if(this.reportType == "" && this.facilitySelectedTab == 'Facility Dashboard'){
    this.messageService.add({
      key: 'save',
      severity: 'error',
      summary: 'Please ',
      detail: 'Please select REPORT TYPE first.',
    });
    this.reportTypeError = true;
    setTimeout(() => {
      this.reportTypeError = false;
    }, 1000);
    return;
  }
  
  if(this.selctReportOption == 'daily'){
    if(this.fromMonth == null){
      this.messageService.add({
        key: 'save',
        severity: 'error',
        summary: 'Error ',
        detail: `Please select FROM DATE first.`,
      });
      this.fromDateErrorBool = true;
      setTimeout(() => {
      this.fromDateErrorBool = false;
      }, 1000);
      this.DateFormate();
      return;
    }
    if(this.toMonth == null){
      this.messageService.add({
        key: 'save',
        severity: 'error',
        summary: 'Error ',
        detail: 'Please select TO DATE first.',
      });
      this.toDateErrorBool = true;
      setTimeout(() => {
      this.toDateErrorBool = false;
      }, 1000);
      this.DateFormate();
      return;
    }
  }
  
  if(this.workFlowTypeRAPIDiBool == true && this.facilitySelectedTab == 'RAPIDi Notification' ||
     this.workFlowTypePITrendBool == true && this.facilitySelectedTab == 'PI Trends'){
    this.messageService.add({
      key: 'save',
      severity: 'error',
      summary: 'Please ',
      detail: 'Please select WorkFlow Type first.',
    });
    this.workFlowTypeColorBool = true;
    setTimeout(() => {
      this.workFlowTypeColorBool = false;
    }, 1000);
    this.DateFormate();
    return;
  }
  if(this.selctReportOption == 'monthly' || this.selctReportOption == 'cumulative'){
    if(this.fromMonth == null){
      this.messageService.add({
        key: 'save',
        severity: 'error',
        summary: 'Error ',
        detail: `Please select FROM MONTH first.`,
      });
      this.fromMonthErrorBool = true;
      setTimeout(() => {
      this.fromMonthErrorBool = false;
      }, 1000);
      return;
    }
    if(this.toMonth == null){
      this.messageService.add({
        key: 'save',
        severity: 'error',
        summary: 'Error ',
        detail: 'Please select TO MONTH first.',
      });
      this.toMonthErrorBool = true;
      setTimeout(() => {
      this.toMonthErrorBool = false;
      }, 1000);
      return;
    }
  }
  if(this.fromMonth == null && this.selctReportOption == 'weekly'){
    this.messageService.add({
      key: 'save',
      severity: 'error',
      summary: 'Please ',
      detail: 'Please SELECT WEEK first.',
    });
    this.weekErrorBool = true;
      setTimeout(() => {
      this.weekErrorBool = false;
      }, 1000);
    return;
  }
  if(this.fromToMonthErrorBool == true){
    this.messageService.add({
      key: 'save',
      severity: 'error',
      summary: 'Please ',
      detail: 'To Month should be greater then From Month.',
    });
    this.fromMonthErrorBool = true;
    this.toMonthErrorBool = true;
    setTimeout(() => {
      this.fromMonthErrorBool = false;
      this.toMonthErrorBool = false;
    }, 1000);
    return;
  }
  if(this.fromToDateErrorBool == true){
    this.messageService.add({
      key: 'save',
      severity: 'error',
      summary: 'Please ',
      detail: 'To Date should be greater then From Date.',
    });
    this.fromDateErrorBool = true;
    this.toDateErrorBool = true;
    setTimeout(() => {
    this.fromDateErrorBool = false;
    this.toDateErrorBool = false;
    }, 1000);
    this.DateFormate();
    return;
  }
  this.selectFacilityPIOptions == "";
  }
  }

  DateFormate(){
    if(this.fromMonth != null){
      this.fromMonth = new Date(this.fromMonth);
    }
    if(this.toMonth != null){
      this.toMonth = new Date(this.toMonth);
    }
  }

  getAllPieChartsData() {

this.analyzeService._facilityPiFilterObj.FacilityDashboardDataObj.data.Status = 'Facility Dashboard';
      this.improveService.GetPieChartData(this.RoleName, this.UId,this.analyzeService._facilityPiFilterObj.FacilityDashboardDataObj).subscribe({
        next: (res: any) => {
          if (res) {
            this.selectedDateVolumetric = [];
          this.firstMonthDateVolumetric = [];
          this.selectedDateStrokeAlert = [];
          this.selectedDateVolumetric = res.selectedDateVolumetric.data;
          this.firstMonthDateVolumetric = res.firstMonthDateVolumetric.data;
          this.selectedDateStrokeAlert = res.selectedDateStrokeAlert.data;
          this.getPiChartForAllCharts();
          }
        },
        error: (err: any) => { },
      })
  }

  getPiChartForAllCharts() {
    if(this.selectedDateVolumetric.length > 0){
    let New = 0;
    let eeg = 0;
    let followup = 0
    let stat = 0;
    let strokealert = 0;
    let StrokeOnSameCart = 0;
    this.minDateSelectedVolumetric = '';
    this.maxDateSelectedVolumetric = '';
    this.minDateSelectedVolumetric = this.selectedDateVolumetric[0].date;
    this.maxDateSelectedVolumetric = this.selectedDateVolumetric[this.selectedDateVolumetric.length - 1].date;
    this.selectedDateVolumetric.forEach((element: any) => {
      New += element.New;
      eeg += element.eeg;
      followup += element.followup;
      stat += element.stat;
      strokealert += element.strokealert;
      StrokeOnSameCart += element.StrokeOnSameCart;
    });
    this.TotaAllCasesSelectedVolimatric = New + eeg + followup + stat + strokealert + StrokeOnSameCart;
    this.pieDataSelectedVolimatric = [
      { category: 'StrokeAlert', value: strokealert , colorField:"#ed1878"},
      { category: 'STAT', value: stat, colorField:"#00164c" },
      { category: 'New', value: New, colorField:"#9f1f60" },
      { category: 'FollowUp', value: followup, colorField:"#653193" },
      { category: 'EEG', value: eeg, colorField:"#00aeef" },
      { category: 'Stroke on Same Cart', value: StrokeOnSameCart, colorField:"#808080" },
    ];
    let val :any;
    val = this.selectedDateVolumetric.every((val:any) => {
      return val.New === 0 && val.eeg === 0 && val.followup === 0 && val.stat === 0 && val.strokealert === 0 && val.StrokeOnSameCart === 0
    });
    if(val){
      this.selectedDateVolumetricBool = true;
    }else{
      this.selectedDateVolumetricBool = false;
    }
  }
  if(this.firstMonthDateVolumetric.length > 0){
    let New = 0;
    let eeg = 0;
    let followup = 0
    let stat = 0;
    let strokealert = 0;
    let StrokeOnSameCart = 0;
    this.minDateFirstMonthVolumetric = '';
    this.maxDateFirstMonthVolumetric = '';
    this.minDateFirstMonthVolumetric = this.firstMonthDateVolumetric[0].date;
    this.maxDateFirstMonthVolumetric = this.firstMonthDateVolumetric[this.firstMonthDateVolumetric.length - 1].date;
    this.firstMonthDateVolumetric.forEach((element: any) => {
      New += element.New;
      eeg += element.eeg;
      followup += element.followup;
      stat += element.stat;
      strokealert += element.strokealert;
      StrokeOnSameCart += element.StrokeOnSameCart;
    });
    this.TotaAllFirstMonthDateVolumetric = New + eeg + followup + stat + strokealert + StrokeOnSameCart;
    this.firstMonthDateVolumetric = [
      { category: 'StrokeAlert', value: strokealert , colorField:"#ed1878"},
      { category: 'STAT', value: stat, colorField:"#00164c" },
      { category: 'New', value: New, colorField:"#9f1f60" },
      { category: 'FollowUp', value: followup, colorField:"#653193" },
      { category: 'EEG', value: eeg, colorField:"#00aeef" },
      { category: 'Stroke on Same Cart', value: StrokeOnSameCart, colorField:"#808080" },
    ];
    let val :any;
    val = this.firstMonthDateVolumetric.every((val:any) => {
      return val.value === 0
    });
    if(val){
      this.firstMonthDateVolumetricBool = true;
    }else{
      this.firstMonthDateVolumetricBool = false;
    }
  }
  if(this.selectedDateStrokeAlert.length > 0){
    let EMS = 0;
    let Triage = 0;
    let Inpatient = 0
    let EdOnset = 0;
    let AudioConsult = 0;
    let SameCart = 0;
    this.minDateSelectedStrokeAlert = '';
    this.maxDateSelectedStrokeAlert = '';
    this.minDateSelectedStrokeAlert = this.selectedDateStrokeAlert[0].date;
    this.maxDateSelectedStrokeAlert = this.selectedDateStrokeAlert[this.selectedDateStrokeAlert.length - 1].date;
    this.selectedDateStrokeAlert.forEach((element: any) => {
      EMS += element.EMS;
      Triage += element.Triage;
      Inpatient += element.Inpatient;
      EdOnset += element.EDOnset;
      AudioConsult += element.AudioConsult;
      SameCart += element.SameCart;
    });
    this.TotaAllSelectedDateStrokeAlert = EMS + Triage + Inpatient + EdOnset + AudioConsult + SameCart;
    this.pieDataSelectedDateStrokeAlert = [
      { category: 'EMS', value: EMS, colorField:"#ed1878" },
      { category: 'Triage', value: Triage, colorField:"#00164c" },
      { category: 'Inpatient', value: Inpatient, colorField:"#9f1f60" },
      { category: 'ED Onset', value: EdOnset, colorField:"#653193" },
      { category: 'Audio Consult', value: AudioConsult, colorField:"#00aeef" },
      { category: 'Stroke on Same Cart', value: SameCart, colorField:"#808080" },
    ];
    let val :any;
    val = this.selectedDateStrokeAlert.every((val:any) => {
      return val.EMS === 0 && val.Triage === 0 && val.Inpatient === 0 && val.EDOnset === 0 && val.AudioConsult === 0 && val.SameCart === 0
    });
    if(val){
      this.selectedDateStrokeAlertBool = true;
    }else{
      this.selectedDateStrokeAlertBool = false;
    }
  }
  this.FacilityDashboardLoader = false;
  this.allChartBool = true;
  }
  public labelContent(args: LegendLabelsContentArgs): string {
    const result = args.dataItem.category + ": \n" + args.dataItem.value;
    return result;
  }
  visualContent = (e: SeriesLabelsVisualArgs) => {
    try {
      const defaultLabel: any = e.createVisual();
      const value = parseFloat(e.text);
      defaultLabel.children
      const font = defaultLabel.children[2].chartElement.options.font;
      defaultLabel.children[2].chartElement.options.font = `bold 15px -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, "Noto Sans", sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji"`;
      defaultLabel.children[2].chartElement.options.color = "#653193";
      return defaultLabel;
    } catch (error) {
      throw error;
    }
  }

  getFacilityDashboardAllCharts() {
    this.FacilityDashboardLoader = true;
    this.chartDatasets = [];
    this.barChartDatasets = [];
    // this.excel_chartDisabe.value = true;
    this.chartFoundBool = false;
    this.analyzeService.GetFacilityDashboardAllChartValues(this.RoleName,this.UId,this.analyzeService._facilityPiFilterObj.FacilityDashboardDataObj)
      .subscribe({
        next: (res: any) => {
          if (res) {
            // this.allChartBool = true;
            this.allChartsData = res.data;
            this.emptyArrays();
              if(res.data[0].Title == null){
                this.chartFoundBool = true;
              }

            this.allChartsData.forEach((item: any) => {

              if (item.Title == 'Door to TS Notification Ave. & Median Minutes') {
                this.flag = 0;
                this.doortostarttitle = item.Title;
                this.doortostartmean = item.Mean;
                this.doortostartmedian = item.Median;
                this.doortostartcatgory = item.Category;
                const ceckNullValuesMean = item.MeanCalculation.filter((i:any)=> i!= null);
                const ceckNullValuesMedian = item.MedianCalculation.filter((i:any)=> i!= null);
                if(ceckNullValuesMean.length > 0 || ceckNullValuesMedian.length > 0){
                this.minDoortostartVal = new Date(item.MinDate).getTime();
                }
                item.MeanCalculation.forEach((value: any) => {
                  if (value != null) {
                    this.doortostartmeancal.push(new Date(item.MinDate + ' ' + value).getTime());
                  }
                  else {
                    this.doortostartmeancal.push(value);
                  }
                });
                item.MedianCalculation.forEach((value: any) => {
                  if (value != null) {
                    this.doortostartmediancal.push(new Date(item.MinDate + ' ' + value).getTime());
                  }
                  else {
                    this.doortostartmediancal.push(value);
                  }
                });

                let mergedDoortostartArray = [...this.doortostartmeancal, ...this.doortostartmediancal];
                this.maxDoortostartVal = Math.max(...mergedDoortostartArray);
              }
              else if (item.Title == "% 10 Min or Less Activation (EMS)") {
                let transformedData= [];
                let transformedDataInitial:any;
                 transformedDataInitial = item.Category;
                 if(transformedDataInitial){
                transformedData = transformedDataInitial.map((element:any) => {
                  const index = element.indexOf("N=");
                  return index !== -1 ? element.substring(0, index) : element;
                });
              }

                this.activationemscatgory = transformedData;
                this.activationemsmeancal = item.MeanCalculation;
                
              }
              else if (item.Title == "% 10 Min or Less Activation (PV)") {
                this.activationpvmeancal = item.MeanCalculation;
              }
              else if (item.Title == "Activation to Assessment Median Mins") {
                this.flag = 0;
                this.ActivationtoAssessmenttitle = item.Title;
                this.ActivationtoAssessmentmean = item.Mean;
                this.ActivationtoAssessmentmedian = item.Median;
                this.ActivationtoAssessmentcatgory = item.Category;
                const ceckNullValuesMean = item.MeanCalculation.filter((i:any)=> i!= null);
                const ceckNullValuesMedian = item.MedianCalculation.filter((i:any)=> i!= null);
                if(ceckNullValuesMean.length > 0 || ceckNullValuesMedian.length > 0){
                this.minActivationtoAssessmentVal = new Date(item.MinDate).getTime();
                }

                item.MeanCalculation.forEach((value: any) => {
                  if (value != null) {
                    this.ActivationtoAssessmentmeancal.push(new Date(item.MinDate + ' ' + value).getTime());
                  }
                  else {
                    this.ActivationtoAssessmentmeancal.push(value);

                  }
                });
                item.MedianCalculation.forEach((value: any) => {
                  if (value != null) {
                    this.ActivationtoAssessmentmediancal.push(new Date(item.MinDate + ' ' + value).getTime());
                  }
                  else {
                    this.ActivationtoAssessmentmediancal.push(value);
                  }
                });

                let mergedActivationtoAssessmentArray = [...this.ActivationtoAssessmentmeancal, ...this.ActivationtoAssessmentmediancal];
                this.maxActivationtoAssessmentVal = Math.max(...mergedActivationtoAssessmentArray);
              }
              else if (item.Title == "TS Notification to Initial Response Average & Median Minute") {
                this.flag = 0;
                this.starttoresponsetitle = item.Title;
                this.starttoresponsemean = item.Mean;
                this.starttoresponsemedian = item.Median;
                this.starttoresponsecatgory = item.Category;
                const ceckNullValuesMean = item.MeanCalculation.filter((i:any)=> i!= null);
                const ceckNullValuesMedian = item.MedianCalculation.filter((i:any)=> i!= null);
                if(ceckNullValuesMean.length > 0 || ceckNullValuesMedian.length > 0){
                this.minStarttoresponseVal = new Date(item.MinDate).getTime();
                }
                this.starttoresponsemeancal = [];
                this.starttoresponsemediancal = [];

                item.MeanCalculation.forEach((value: any) => {
                  if (value != null) {
                    this.starttoresponsemeancal.push(new Date(item.MinDate + ' ' + value).getTime());
                  }
                  else {
                    this.starttoresponsemeancal.push(value);
                  }
                });
                item.MedianCalculation.forEach((value: any) => {
                  if (value != null) {
                    this.starttoresponsemediancal.push(new Date(item.MinDate + ' ' + value).getTime());
                  }
                  else {
                    this.starttoresponsemediancal.push(value);
                  }
                });

                let mergedstarttoresponseArray = [...this.starttoresponsemeancal, ...this.starttoresponsemediancal];
                this.maxStarttoresponseVal = Math.max(...mergedstarttoresponseArray);
              }
              else if (item.Title == "THROMBOLYTIC ADMINISTERED #") {
                this.alteplaseadmintitle = item.Title;
                this.alteplaseadminmean = item.Mean;
                this.alteplaseadmincatgory = item.Category;
                this.alteplaseadminmeancal = item.MeanCalculation;
              }
              else if (item.Title == "Door to Needle Average & Median (min:sec)") {
                this.flag = 0;
                this.doortoneedletitle = item.Title;
                this.doortoneedlemean = item.Mean;
                this.doortoneedlemedian = item.Median;
                this.doortoneedlecatgory = item.Category;
                const ceckNullValuesMean = item.MeanCalculation.filter((i:any)=> i!= null);
                const ceckNullValuesMedian = item.MedianCalculation.filter((i:any)=> i!= null);
                if(ceckNullValuesMean.length > 0 || ceckNullValuesMedian.length > 0){
                this.minDoortoneedleVal = new Date(item.MinDate).getTime();
                }

                item.MeanCalculation.forEach((value: any) => {
                  if (value != null) {
                    this.doortoneedlemeancal.push(new Date(item.MinDate + ' ' + value).getTime());
                  }
                  else {
                    this.doortoneedlemeancal.push(value);
                  }
                });
                item.MedianCalculation.forEach((value: any) => {
                  if (value != null) {
                    this.doortoneedlemediancal.push(new Date(item.MinDate + ' ' + value).getTime());
                  }
                  else {
                    this.doortoneedlemediancal.push(value);
                  }
                });

                let mergeddoortoneedleArray = [...this.doortoneedlemeancal, ...this.doortoneedlemediancal];
                this.maxDoortoneedleVal = Math.max(...mergeddoortoneedleArray);
              }
              else if (item.Title == "Activation to Needle Average & Median") {
                this.flag = 0;
                this.activitationtoneedletitle = item.Title;
                this.activitationtoneedlemean = item.Mean;
                this.activitationtoneedlemedian = item.Median;
                this.activitationtoneedlecatgory = item.Category;
                const ceckNullValuesMean = item.MeanCalculation.filter((i:any)=> i!= null);
                const ceckNullValuesMedian = item.MedianCalculation.filter((i:any)=> i!= null);
                if(ceckNullValuesMean.length > 0 || ceckNullValuesMedian.length > 0){
                this.minActivitationtoneedleVal = new Date(item.MinDate).getTime();
                }

                item.MeanCalculation.forEach((value: any) => {
                  if(value != null){
                  this.activitationtoneedlemeancal.push(new Date(item.MinDate + ' ' + value).getTime());
                }
                else{
                    this.activitationtoneedlemeancal.push(value);
                  }
                });
                item.MedianCalculation.forEach((value: any) => {
                  if(value != null){
                  this.activitationtoneedlemediancal.push(new Date(item.MinDate + ' ' + value).getTime());
                }
                else{
                  this.activitationtoneedlemediancal.push(value);
                  }
                });

                let mergedactivitationtoneedleArray = [...this.activitationtoneedlemeancal, ...this.activitationtoneedlemediancal];
                this.maxActivitationtoneedleVal = Math.max(...mergedactivitationtoneedleArray);
              }
              else if (item.Title == "Assessment to Thrombolytic Decision-making Median Mins") {
                this.flag = 0;
                this.AssessmenttoThrombolytictitle = item.Title;
                this.AssessmenttoThrombolyticmean = item.Mean;
                this.AssessmenttoThrombolyticmedian = item.Median;
                this.AssessmenttoThrombolyticcatgory = item.Category;
                const ceckNullValuesMean = item.MeanCalculation.filter((i:any)=> i!= null);
                const ceckNullValuesMedian = item.MedianCalculation.filter((i:any)=> i!= null);
                if(ceckNullValuesMean.length > 0 || ceckNullValuesMedian.length > 0){
                this.minAssessmenttoThrombolyticval = new Date(item.MinDate).getTime();
                }

                item.MeanCalculation.forEach((value: any) => {
                  if (value != null) {
                    this.AssessmenttoThrombolyticmeancal.push(new Date(item.MinDate + ' ' + value).getTime());
                  }
                  else {
                    this.AssessmenttoThrombolyticmeancal.push(value);
                  }
                });
                item.MedianCalculation.forEach((value: any) => {
                  if (value != null) {
                    this.AssessmenttoThrombolyticmediancal.push(new Date(item.MinDate + ' ' + value).getTime());
                  }
                  else {
                    this.AssessmenttoThrombolyticmediancal.push(value);
                  }
                });

                let mergedAssessmenttoThrombolyticArray = [...this.AssessmenttoThrombolyticmeancal, ...this.AssessmenttoThrombolyticmediancal];
                this.maxAssessmenttoThrombolyticval = Math.max(...mergedAssessmenttoThrombolyticArray);
              }
              else if (item.Title == "Thrombolytic Decision Making to Admin Median Mins") {
                this.flag = 0;
                this.ThrombolytictoThrombolyticadministrationtitle = item.Title;
                this.ThrombolytictoThrombolyticadministrationavg = item.Mean;
                this.ThrombolytictoThrombolyticadministrationmedian = item.Median;
                this.ThrombolytictoThrombolyticadministrationcatgory = item.Category;
                const ceckNullValuesMean = item.MeanCalculation.filter((i:any)=> i!= null);
                const ceckNullValuesMedian = item.MedianCalculation.filter((i:any)=> i!= null);
                if(ceckNullValuesMean.length > 0 || ceckNullValuesMedian.length > 0){
                this.minThrombolytictoThrombolyticadministrationVal = new Date(item.MinDate).getTime();
                }

                item.MeanCalculation.forEach((value: any) => {
                  if (value != null) {
                    this.ThrombolytictoThrombolyticadministrationmeancal.push(new Date(item.MinDate + ' ' + value).getTime());
                  }
                  else {
                    this.ThrombolytictoThrombolyticadministrationmeancal.push(value);
                  }
                });
                item.MedianCalculation.forEach((value: any) => {
                  if (value != null) {
                    this.ThrombolytictoThrombolyticadministrationmediancal.push(new Date(item.MinDate + ' ' + value).getTime());
                  }
                  else {
                    this.ThrombolytictoThrombolyticadministrationmediancal.push(value);
                  }
                });

                let mergedThrombolytictoThrombolyticadministrationArray = [...this.ThrombolytictoThrombolyticadministrationmeancal, ...this.ThrombolytictoThrombolyticadministrationmediancal];
                this.maxThrombolytictoThrombolyticadministrationVal = Math.max(...mergedThrombolytictoThrombolyticadministrationArray);
              }
              else if (item.Title == "DTN Less or Equal 30 Minutes %") {
                this.DTN30percentmean = item.Mean;
                this.DTN30percentcatgory = item.Category;
                this.DTN30percentmeancal = item.MeanCalculation
              }
              else if (item.Title == "DTN Less or Equal 45 Minutes %") {
                this.DTN45percentmeancal = item.MeanCalculation;
              }
              else if (item.Title == "DTN Less or Equal 60 Minutes %") {
                this.DTN60percentmeancal = item.MeanCalculation;
              }
              else if (item.Title == "Door to NIR Callback Ave. & Median Minutes") {
                this.flag = 0;
                this.doortonircallbacktitle = item.Title;
                this.doortonircallbackmean = item.Mean;
                this.doortonircallbackmedian = item.Median;
                this.doortonircallbackcatgory = item.Category;
                const ceckNullValuesMean = item.MeanCalculation.filter((i:any)=> i!= null);
                const ceckNullValuesMedian = item.MedianCalculation.filter((i:any)=> i!= null);
                if(ceckNullValuesMean.length > 0 || ceckNullValuesMedian.length > 0){
                this.minDoortonircallbackVal = new Date(item.MinDate).getTime();
                }

                item.MeanCalculation.forEach((value: any) => {
                  if (value != null) {
                    this.doortonircallbackmeancal.push(new Date(item.MinDate + ' ' + value).getTime());
                  }
                  else {
                    this.doortonircallbackmeancal.push(value);

                  }
                });
                item.MedianCalculation.forEach((value: any) => {
                  if (value != null) {
                    this.doortonircallbackmediancal.push(new Date(item.MinDate + ' ' + value).getTime());
                  }
                  else {
                    this.doortonircallbackmediancal.push(value);
                  }
                });
              }
            });

            this.Door_to_TS_Notification_Ave_Median_Minutes_Chart(this.doortostarttitle, this.doortostartmean, this.doortostartmedian, this.doortostartmeancal, this.doortostartmediancal, this.doortostartcatgory, this.flag);
            this.Ten_Min_or_Less_Activation_EMS_PV_Chart(this.activationemsmeancal, this.activationpvmeancal, this.activationemscatgory);
            this.Activation_to_Assessment_Median_Mins_Chart(this.ActivationtoAssessmenttitle, this.ActivationtoAssessmentmean, this.ActivationtoAssessmentmedian, this.ActivationtoAssessmentmeancal, this.ActivationtoAssessmentmediancal, this.ActivationtoAssessmentcatgory, this.flag);
            this.TS_Notification_to_Initial_Response_Average_Median_Minute_Chart(this.starttoresponsetitle, this.starttoresponsemean, this.starttoresponsemedian, this.starttoresponsemeancal, this.starttoresponsemediancal, this.starttoresponsecatgory, this.flag);
            this.Door_to_Needle_Average_Median_min_sec_Chart(this.doortoneedletitle, this.doortoneedlemean, this.doortoneedlemedian, this.doortoneedlemeancal, this.doortoneedlemediancal, this.doortoneedlecatgory, this.flag);
            this.Activation_to_Needle_Average_Median_Chart(this.activitationtoneedletitle, this.activitationtoneedlemean, this.activitationtoneedlemedian, this.activitationtoneedlemeancal, this.activitationtoneedlemediancal, this.activitationtoneedlecatgory, this.flag);
            this.Assessment_to_Thrombolytic_Decision_making_Median_Mins_Chart(this.AssessmenttoThrombolytictitle, this.AssessmenttoThrombolyticmean, this.AssessmenttoThrombolyticmedian, this.AssessmenttoThrombolyticmeancal, this.AssessmenttoThrombolyticmediancal, this.AssessmenttoThrombolyticcatgory, this.flag);
            this.Thrombolytic_Decision_Making_to_Admin_Median_Mins_Chart(this.ThrombolytictoThrombolyticadministrationavg, this.ThrombolytictoThrombolyticadministrationmedian, this.ThrombolytictoThrombolyticadministrationmeancal, this.ThrombolytictoThrombolyticadministrationmediancal, this.ThrombolytictoThrombolyticadministrationcatgory, this.flag);
            this.DTN_30_45_60_Chart(this.DTN30percentmeancal, this.DTN45percentmeancal, this.DTN60percentmeancal, this.DTN30percentcatgory);

          }
          // this.excel_chartDisabe.value = false;
          // this.FacilityDashboardLoader = false;
        }
      });
  }
  emptyArrays(){
    this.doortostartmeancal = [];
    this.doortostartmediancal = [];
    this.doortostartcatgory = [];
    this.activationemsmeancal = [];
    this.activationemscatgory = [];
    this.activationpvmeancal = [];
    this.ActivationtoAssessmentcatgory = [];
    this.ActivationtoAssessmentmediancal = [];
    this.ActivationtoAssessmentmeancal = [];
    this.starttoresponsecatgory = [];
    this.starttoresponsemeancal = [];
    this.starttoresponsemediancal = [];
    this.alteplaseadmincatgory = [];
    this.alteplaseadminmeancal = [];
    this.doortoneedlecatgory = [];
    this.doortoneedlemeancal = [];
    this.doortoneedlemediancal = [];
    this.activitationtoneedlecatgory = []
    this.activitationtoneedlemeancal = [];
    this.activitationtoneedlemediancal = [];
    this.AssessmenttoThrombolyticcatgory = [];
    this.AssessmenttoThrombolyticmeancal = [];
    this.AssessmenttoThrombolyticmediancal = [];
    this.ThrombolytictoThrombolyticadministrationcatgory = [];
    this.ThrombolytictoThrombolyticadministrationmeancal = [];
    this.ThrombolytictoThrombolyticadministrationmediancal = [];
    this.DTN30percentcatgory = [];
    this.DTN30percentmeancal = [];
    this.DTN45percentmeancal = [];
    this.DTN60percentmeancal = [];
  };

  public seriesColors: any = ['#ed2078', '#36286b', '#3B82F6'];
  doortostartMeanChart: any = [];
  doortostartMedianChart: any = [];
  doortostartMeanChartContent: any;
  doortostartMedianChartContent: any;

  Door_to_TS_Notification_Ave_Median_Minutes_Chart(Title: any, Mean: any, Median: any, MeanCalculations: any, MedianCalculations: any, Category: any, flag: any) {
    let doortostartMeanChartDate: any = []
    let doortostartMeanChartDateClone: any = []
    let doortostartMedianChartDate: any = []
    let doortostartMedianChartDateClone: any = []

    this.doortostartmeancal.forEach((value: any) => {
      if (value != null) {
      let calculatedDate = new Date(value).getHours() * 60 + new Date(value).getMinutes() + ':' + new Date(value).getSeconds().toString().padStart(2, '0');
      doortostartMeanChartDate.push(calculatedDate);
      doortostartMeanChartDateClone.push(calculatedDate);
    }
    else{
        doortostartMeanChartDate.push(value);        
      }
      });
      this.doortostartMeanChart = doortostartMeanChartDate.map((str:any) => str == null ? null : parseInt(str, 10));
    let dttsnmn = -1;
    this.doortostartMeanChartContent = (e: SeriesLabelsContentArgs): string => {
      if(dttsnmn == doortostartMeanChartDateClone.length - 1){
        dttsnmn = -1;
      }
      dttsnmn++
      return  doortostartMeanChartDateClone[dttsnmn];
    };

    

    this.doortostartmediancal.forEach((value: any) => {
      if (value != null) {
      let calculatedDate = new Date(value).getHours() * 60 + new Date(value).getMinutes() + ':' + new Date(value).getSeconds().toString().padStart(2, '0');
      doortostartMedianChartDate.push(calculatedDate);
      doortostartMedianChartDateClone.push(calculatedDate);
    }
    else{
        doortostartMedianChartDate.push(null);
      }
      });
      this.doortostartMedianChart = doortostartMedianChartDate.map((str:any) => str == null ? null : parseInt(str, 10));
    let dttsnnmd = -1;
    this.doortostartMedianChartContent = (e: SeriesLabelsContentArgs): string => {
      if(dttsnnmd == doortostartMedianChartDateClone.length - 1){
        dttsnnmd = -1;
      }
      dttsnnmd++
      return  doortostartMedianChartDateClone[dttsnnmd];
    };

  }


  Ten_Min_or_Less_Activation_EMS_PV_Chart(EMSMeanCalculations: any, PVMeanCalculations: any, Category: any) {
    this.Ten_Min_or_Less_Activation_EMS_PV_Chart_Data = [];
    
  }

  ActivationtoAssessmentMeanChart: any = [];
  ActivationtoAssessmentMedianChart: any = [];
  ActivationtoAssessmentMeanChartContent: any;
  ActivationtoAssessmentMedianChartContent: any;

  Activation_to_Assessment_Median_Mins_Chart(Title: any, Mean: any, Median: any, MeanCalculations: any, MedianCalculations: any, Category: any, flag: any) {
    let acivationToAssessmentMeanChartDate: any = []
    let acivationToAssessmentMeanChartDateClone: any = []
    let acivationToAssessmentMedianChartDate: any = []
    let acivationToAssessmentMedianChartDateClone: any = []

    

    this.ActivationtoAssessmentmeancal.forEach((value: any) => {
      if(value != null){
      let calculatedDate = new Date(value).getHours() * 60 + new Date(value).getMinutes() + ':' + new Date(value).getSeconds().toString().padStart(2, '0');
      acivationToAssessmentMeanChartDate.push(calculatedDate)
      acivationToAssessmentMeanChartDateClone.push(calculatedDate)
    }
    else{
      acivationToAssessmentMeanChartDate.push(value);      
      }
      });
      this.ActivationtoAssessmentMeanChart = acivationToAssessmentMeanChartDate.map((str:any) => str == null ? null :parseInt(str, 10));
    let atatmn = -1
    this.ActivationtoAssessmentMeanChartContent = (e: SeriesLabelsContentArgs): string => {
      if(atatmn == acivationToAssessmentMeanChartDateClone.length - 1){
        atatmn = -1;
      }
      atatmn++
      return  acivationToAssessmentMeanChartDateClone[atatmn];
    };

    

    this.ActivationtoAssessmentmediancal.forEach((value: any) => {
      if (value != null) {
        let calculatedDate = new Date(value).getHours() * 60 + new Date(value).getMinutes() + ':' + new Date(value).getSeconds().toString().padStart(2, '0');
        acivationToAssessmentMedianChartDate.push(calculatedDate)
        acivationToAssessmentMedianChartDateClone.push(calculatedDate)
      }
      else {
        acivationToAssessmentMedianChartDate.push(value)
      }
      });
      this.ActivationtoAssessmentMedianChart = acivationToAssessmentMedianChartDate.map((str:any) => str == null ? null : parseInt(str, 10));
    let atatmd = -1
    this.ActivationtoAssessmentMedianChartContent = (e: SeriesLabelsContentArgs): string => {
      if(atatmd == acivationToAssessmentMedianChartDateClone.length - 1){
        atatmd = -1;
      }
      atatmd++
      return acivationToAssessmentMedianChartDateClone[atatmd];
    };

  }

  TS_Notification_to_Initial_ResponseMeanChart: any = [];
  TS_Notification_to_Initial_ResponseMedianChart: any = [];
  TS_Notification_to_Initial_ResponseMeanChartContent: any;
  TS_Notification_to_Initial_ResponseMedianChartContent: any;

  TS_Notification_to_Initial_Response_Average_Median_Minute_Chart(Title: any, Mean: any, Median: any, MeanCalculations: any, MedianCalculations: any, Category: any, flag: any) {
    
    let TS_Notification_to_Initial_ResponseMeanChartDate: any = []
    let TS_Notification_to_Initial_ResponseMeanChartDateClone: any = []
    let TS_Notification_to_Initial_ResponseMedianChartDate: any = []
    let TS_Notification_to_Initial_ResponseMedianChartDateClone: any = []

    this.starttoresponsemeancal.forEach((value: any) => {
      if (value != null) {
        let calculatedDate = new Date(value).getHours() * 60 + new Date(value).getMinutes() + ':' + new Date(value).getSeconds().toString().padStart(2, '0');
        TS_Notification_to_Initial_ResponseMeanChartDate.push(calculatedDate)
        TS_Notification_to_Initial_ResponseMeanChartDateClone.push(calculatedDate)
      }
      else {
        TS_Notification_to_Initial_ResponseMeanChartDate.push(value)
      }
    });
      this.TS_Notification_to_Initial_ResponseMeanChart = TS_Notification_to_Initial_ResponseMeanChartDate.map((str:any) => str == null ? null : parseInt(str, 10));
    let tsntirmn = -1
    this.TS_Notification_to_Initial_ResponseMeanChartContent = (e: SeriesLabelsContentArgs): string => {
      if(tsntirmn == TS_Notification_to_Initial_ResponseMeanChartDateClone.length - 1){
        tsntirmn = -1
      }
      tsntirmn++
      return TS_Notification_to_Initial_ResponseMeanChartDateClone[tsntirmn];
    };

    

    this.starttoresponsemediancal.forEach((value: any) => {
      if (value != null) {
        let calculatedDate = new Date(value).getHours() * 60 + new Date(value).getMinutes() + ':' + new Date(value).getSeconds().toString().padStart(2, '0');
        TS_Notification_to_Initial_ResponseMedianChartDate.push(calculatedDate)
        TS_Notification_to_Initial_ResponseMedianChartDateClone.push(calculatedDate)
      }
      else {
        TS_Notification_to_Initial_ResponseMedianChartDate.push(value)
      }
    });
      this.TS_Notification_to_Initial_ResponseMedianChart = TS_Notification_to_Initial_ResponseMedianChartDate.map((str:any) => str == null ? null : parseInt(str, 10));
    let tsntirmd = -1
    this.TS_Notification_to_Initial_ResponseMedianChartContent = (e: SeriesLabelsContentArgs): string => {
      if(tsntirmd == TS_Notification_to_Initial_ResponseMedianChartDateClone.length - 1){
        tsntirmd = -1;
      }
      tsntirmd++
      return TS_Notification_to_Initial_ResponseMedianChartDateClone[tsntirmd];
    };

  }

  Door_to_NeedleMeanChart: any = [];
  Door_to_NeedleMedianChart: any = [];
  Door_to_NeedleMeanChartContent: any;
  Door_to_NeedleMedianChartContent: any;

  Door_to_Needle_Average_Median_min_sec_Chart(Title: any, Mean: any, Median: any, MeanCalculations: any, MedianCalculations: any, Category: any, flag: any) {
    let Door_to_NeedleMeanChartDate: any = []
    let Door_to_NeedleMeanChartDateClone: any = []
    let Door_to_NeedleMedianChartDate: any = []
    let Door_to_NeedleMedianChartDateClone: any = []

    

    this.doortoneedlemeancal.forEach((value: any) => {
      if(value != null){
      let calculatedDate = new Date(value).getHours() * 60 + new Date(value).getMinutes() + ':' + new Date(value).getSeconds().toString().padStart(2, '0');
      Door_to_NeedleMeanChartDate.push(calculatedDate)
      Door_to_NeedleMeanChartDateClone.push(calculatedDate)
    }
    else{
      Door_to_NeedleMeanChartDate.push(value)      
      }
      });
      this.Door_to_NeedleMeanChart = Door_to_NeedleMeanChartDate.map((str:any) => str == null ? null : parseInt(str, 10));
    let dtnmn = -1
    this.Door_to_NeedleMeanChartContent = (e: SeriesLabelsContentArgs): string => {
      if(dtnmn == Door_to_NeedleMeanChartDateClone.length - 1){
        dtnmn = -1;
      }
      dtnmn++
      return Door_to_NeedleMeanChartDateClone[dtnmn];
    };


    this.doortoneedlemediancal.forEach((value: any) => {
      if(value != null){
      let calculatedDate = new Date(value).getHours() * 60 + new Date(value).getMinutes() + ':' + new Date(value).getSeconds().toString().padStart(2, '0');
      Door_to_NeedleMedianChartDate.push(calculatedDate)
      Door_to_NeedleMedianChartDateClone.push(calculatedDate)
    }
    else{
      Door_to_NeedleMedianChartDate.push(value)      
      }
      });
      this.Door_to_NeedleMedianChart = Door_to_NeedleMedianChartDate.map((str:any) => str == null ? null : parseInt(str, 10));
    let dtnmd = -1
    this.Door_to_NeedleMedianChartContent = (e: SeriesLabelsContentArgs): string => {
      if(dtnmd == Door_to_NeedleMedianChartDateClone.length - 1){
        dtnmd = -1;
      }
      dtnmd++
      return Door_to_NeedleMedianChartDateClone[dtnmd];
    };
    
  }

  Activation_to_NeedleMeanChart: any = [];
  Activation_to_NeedleMedianChart: any = [];
  Activation_to_NeedleMeanChartContent: any;
  Activation_to_NeedleMedianChartContent: any;

  Activation_to_Needle_Average_Median_Chart(Title: any, Mean: any, Median: any, MeanCalculations: any, MedianCalculations: any, Category: any, flag: any) {
    
    let Activation_to_NeedleMeanChartDate: any = []
    let Activation_to_NeedleMeanChartDateClone: any = []
    let Activation_to_NeedleMedianChartDate: any = []
    let Activation_to_NeedleMedianChartDateClone: any = []

    

    this.activitationtoneedlemeancal.forEach((value: any) => {
      if(value != null){
      let calculatedDate = new Date(value).getHours() * 60 + new Date(value).getMinutes() + ':' + new Date(value).getSeconds().toString().padStart(2, '0');
      Activation_to_NeedleMeanChartDate.push(calculatedDate)
      Activation_to_NeedleMeanChartDateClone.push(calculatedDate)
    }
    else{
      Activation_to_NeedleMeanChartDate.push(value)      
      }
      });
      this.Activation_to_NeedleMeanChart = Activation_to_NeedleMeanChartDate.map((str:any) => str == null ? null : parseInt(str, 10));
    let atnmn = -1
    this.Activation_to_NeedleMeanChartContent = (e: SeriesLabelsContentArgs): string => {
      if(atnmn == Activation_to_NeedleMeanChartDateClone.length - 1){
        atnmn = -1
      }
      atnmn++
      return Activation_to_NeedleMeanChartDateClone[atnmn];
    };


    this.activitationtoneedlemediancal.forEach((value: any) => {
      if(value != null){
      let calculatedDate = new Date(value).getHours() * 60 + new Date(value).getMinutes() + ':' + new Date(value).getSeconds().toString().padStart(2, '0');
      Activation_to_NeedleMedianChartDate.push(calculatedDate)
      Activation_to_NeedleMedianChartDateClone.push(calculatedDate)
    }
    else{
      Activation_to_NeedleMedianChartDate.push(value)      
      }
      });
      this.Activation_to_NeedleMedianChart = Activation_to_NeedleMedianChartDate.map((str:any) => str == null ? null : parseInt(str, 10));
    let dtsmn = -1
    this.Activation_to_NeedleMedianChartContent = (e: SeriesLabelsContentArgs): string => {
      if(dtsmn == Activation_to_NeedleMedianChartDateClone.length - 1){
        dtsmn = -1
      }
      dtsmn++
      return Activation_to_NeedleMedianChartDateClone[dtsmn];
    };

  }

  Assessment_to_Thrombolytic_DecisionMeanChart: any = [];
  Assessment_to_Thrombolytic_DecisionMedianChart: any = [];
  Assessment_to_Thrombolytic_DecisionMeanChartContent: any;
  Assessment_to_Thrombolytic_DecisionMedianChartContent: any;

  Assessment_to_Thrombolytic_Decision_making_Median_Mins_Chart(Title: any, Mean: any, Median: any, MeanCalculations: any, MedianCalculations: any, Category: any, flag: any) {
    
    let Assessment_to_Thrombolytic_DecisionMeanChartDate: any = []
    let Assessment_to_Thrombolytic_DecisionMeanChartDateClone: any = []
    let Assessment_to_Thrombolytic_DecisionMedianChartDate: any = []
    let Assessment_to_Thrombolytic_DecisionMedianChartDateClone: any = []

    

    this.AssessmenttoThrombolyticmeancal.forEach((value: any) => {
      if(value != null){
      let calculatedDate = new Date(value).getHours() * 60 + new Date(value).getMinutes() + ':' + new Date(value).getSeconds().toString().padStart(2, '0');
      Assessment_to_Thrombolytic_DecisionMeanChartDate.push(calculatedDate)
      Assessment_to_Thrombolytic_DecisionMeanChartDateClone.push(calculatedDate)
    }
    else{
        Assessment_to_Thrombolytic_DecisionMeanChartDate.push(value)
      }
      });
      this.Assessment_to_Thrombolytic_DecisionMeanChart = Assessment_to_Thrombolytic_DecisionMeanChartDate.map((str:any) => str == null ? null : parseInt(str, 10));
    let attdmmn = -1
    this.Assessment_to_Thrombolytic_DecisionMeanChartContent = (e: SeriesLabelsContentArgs): string => {
      if(attdmmn == Assessment_to_Thrombolytic_DecisionMeanChartDateClone.length - 1){
        attdmmn = -1;
      }
      attdmmn++
      return Assessment_to_Thrombolytic_DecisionMeanChartDateClone[attdmmn];
    };


    this.AssessmenttoThrombolyticmediancal.forEach((value: any) => {
      if(value != null){
      let calculatedDate = new Date(value).getHours() * 60 + new Date(value).getMinutes() + ':' + new Date(value).getSeconds().toString().padStart(2, '0');
      Assessment_to_Thrombolytic_DecisionMedianChartDate.push(calculatedDate)
      Assessment_to_Thrombolytic_DecisionMedianChartDateClone.push(calculatedDate)
    }
    else{
        Assessment_to_Thrombolytic_DecisionMedianChartDate.push(value)
      }
      });
      this.Assessment_to_Thrombolytic_DecisionMedianChart = Assessment_to_Thrombolytic_DecisionMedianChartDate.map((str:any) => str == null ? null : parseInt(str, 10));
    let attdmmd = -1
    this.Assessment_to_Thrombolytic_DecisionMedianChartContent = (e: SeriesLabelsContentArgs): string => {
      if(attdmmd == Assessment_to_Thrombolytic_DecisionMedianChartDateClone.length - 1){
        attdmmd = -1
      }
      attdmmd++
      return Assessment_to_Thrombolytic_DecisionMedianChartDateClone[attdmmd];
    };
  }

  Thrombolytic_Decision_Making_to_AdminMeanChart: any = [];
  Thrombolytic_Decision_Making_to_AdminMedianChart: any = [];
  Thrombolytic_Decision_Making_to_AdminMeanChartContent: any;
  Thrombolytic_Decision_Making_to_AdminMedianChartContent: any;

  Thrombolytic_Decision_Making_to_Admin_Median_Mins_Chart(Mean: any, Median: any, MeanCalculations: any, MedianCalculations: any, Category: any, flag: any) {
    
    let Thrombolytic_Decision_Making_to_AdminMeanChartDate: any = []
    let Thrombolytic_Decision_Making_to_AdminMeanChartDateClone: any = []
    let Thrombolytic_Decision_Making_to_AdminMedianChartDate: any = []
    let Thrombolytic_Decision_Making_to_AdminMedianChartDateClone: any = []

    

    this.ThrombolytictoThrombolyticadministrationmeancal.forEach((value: any) => {
      if(value != null){
      let calculatedDate = new Date(value).getHours() * 60 + new Date(value).getMinutes() + ':' + new Date(value).getSeconds().toString().padStart(2, '0');
      Thrombolytic_Decision_Making_to_AdminMeanChartDate.push(calculatedDate)
      Thrombolytic_Decision_Making_to_AdminMeanChartDateClone.push(calculatedDate)
    }
    else{
        Thrombolytic_Decision_Making_to_AdminMeanChartDate.push(value)
      }
      });
      this.Thrombolytic_Decision_Making_to_AdminMeanChart = Thrombolytic_Decision_Making_to_AdminMeanChartDate.map((str:any) => str == null ? null : parseInt(str, 10));
    let tdmtamn = -1
    this.Thrombolytic_Decision_Making_to_AdminMeanChartContent = (e: SeriesLabelsContentArgs): string => {
      if(tdmtamn == Thrombolytic_Decision_Making_to_AdminMeanChartDateClone.length - 1){
        tdmtamn = -1
      }
      tdmtamn++
      return Thrombolytic_Decision_Making_to_AdminMeanChartDateClone[tdmtamn];
    };


    this.ThrombolytictoThrombolyticadministrationmediancal.forEach((value: any) => {
      if(value != null){
      let calculatedDate = new Date(value).getHours() * 60 + new Date(value).getMinutes() + ':' + new Date(value).getSeconds().toString().padStart(2, '0');
      Thrombolytic_Decision_Making_to_AdminMedianChartDate.push(calculatedDate)
      Thrombolytic_Decision_Making_to_AdminMedianChartDateClone.push(calculatedDate)
    }
    else{
        Thrombolytic_Decision_Making_to_AdminMedianChartDate.push(value)
      }
      });
      this.Thrombolytic_Decision_Making_to_AdminMedianChart = Thrombolytic_Decision_Making_to_AdminMedianChartDate.map((str:any) => str == null ? null : parseInt(str, 10));
    let tdmtamd = -1
    this.Thrombolytic_Decision_Making_to_AdminMedianChartContent = (e: SeriesLabelsContentArgs): string => {
      if(tdmtamd == Thrombolytic_Decision_Making_to_AdminMedianChartDateClone.length - 1){
        tdmtamd = -1
      }
      tdmtamd++
      return Thrombolytic_Decision_Making_to_AdminMedianChartDateClone[tdmtamd];
    };

  }

  DTN30percentmeancalChartContent: any;
  DTN45percentmeancalChartContent: any;
  DTN60percentmeancalChartContent: any;

  DTN_30_45_60_Chart(DTN30MeanCalculations: any, DTN45MeanCalculations: any, DTN60MeanCalculations: any, Category: any) {
    
  }


  showAllCharts() {
    this.showAllChartBool = true;
  }
  hideAllCharts() {
    this.showAllChartBool = false;
  }

  hideChartDiaglog() {
    this.allChartBool = false;
  }

  getPiChart() {
    this.pi_chartBool.value = true;
    if (this.piCharVisibility == true) {
      this.analyzeService._facilityPiComponent.VolumetricsComponent.getPiChart(this.pi_chartBool);
    }
    else if (this.piCharVisibility == false) {
      this.analyzeService._facilityPiComponent.StrokeAlertCasesComponent.getPiChart(this.pi_chartBool);
    }
  }

  excelDownload(workbook: any, fileName: any) {
    workbook.xlsx.writeBuffer().then((data: any) => {
      let blob = new Blob([data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
      FileSaver.saveAs(blob, fileName + '.xlsx');
    })
  }

  SortByNameListForExcel(arr: any, dataKeys: any, identifier: any) {
    let nameList = [];
    let nameListTemp: any = [];
    dataKeys.map((item: any) => {
      if(this.reportType == 'monthly'){
      nameListTemp.push(item.substring(0, 3) + 'Data');
      nameListTemp.push(item.substring(0, 3) + 'Goals');
    }
    else{
      nameListTemp.push(item)
    }
    });
    nameListTemp.unshift('QualityMetrics');
    let Akeys = Object.keys(arr);
    for (let key of Akeys) {
      if (arr[key] == null) {
        delete arr[key];
      }
      nameList.push({ [key]: arr[key] });
    }

    const sortedReport = (a: any, b: any) => {
      const aIndex = nameListTemp.indexOf(Object.keys(a)[0]);
      const bIndex = nameListTemp.indexOf(Object.keys(b)[0]);

       if (aIndex < 0) {
        return 1;
      } else if (bIndex < 0) {
        return -1;
      } else {
        return aIndex - bIndex;
      }
    };
    nameList.sort(sortedReport);
    let sortedDataList = this.convertArrayToObject(nameList, identifier);
    return sortedDataList;
  }

  convertArrayToObject(arr: any, identifier: any) {
    if (identifier == 'data') {
      let dataObj = arr.map((x: any) => {
        return Object.values(x)[0];
      })
      return dataObj;
    }
    else if (identifier == 'header') {
      let headerObj = arr.map((x: any) => {
        return Object.keys(x)[0];
      })
      return headerObj;
    }
  }

  NameListforData(startDate: any, endDate: any) {
    let beginDate = new Date(startDate);
    let lastDate = new Date(endDate);
    let headerList: any = [];
    headerList.push('QualityMetrics');
    if (this.reportType.toLowerCase() == 'monthly') {
      while (beginDate <= endDate) {
        headerList.push(beginDate.toLocaleString('en-US', { month: 'short' }).substring(0, 3) + 'Data ' + beginDate.toLocaleString('en-US', { year: 'numeric' }));
        if (this.facility.toLowerCase() == 'facility') {
          headerList.push(beginDate.toLocaleString('en-US', { month: 'short' }).substring(0, 3) + 'Goals ' + beginDate.toLocaleString('en-US', { year: 'numeric' }));
        }
        beginDate.setMonth(beginDate.getMonth() + 1);
      }
      return headerList;
    }
    else if (this.reportType.toLowerCase() == 'daily') {
      for (let i = beginDate; i <= lastDate; i.setDate(i.getDate() + 1)) {
        headerList.push('Day' + i.getDate());
      }
      return headerList;
    }
    else if (this.reportType.toLowerCase() == 'weekly') {
      headerList.push('Week');
      return headerList;
    }
    else if (this.reportType.toLowerCase() == 'cumulative') {
      headerList.push('Cumulative');
      return headerList;
    }
  }

   exportExcel() {
    this.Observable.value$.next(false);
    let newArray: any = [];
    this.facilityDasboardReplica = [];
    this.exportExcelLoader = true;
    if (this.btnClicked == 1) {
      this.analyzeService._facilityPiRecord.FacilityDashboardRecord.forEach((element: any) => {
        let facilityDashbaordValue: any = [];
        facilityDashbaordValue.push(element.QualityMetrics)
        element.objDailyData.forEach((value: any) => {
          facilityDashbaordValue.push(value.Value)
          facilityDashbaordValue.push(value.Goal)
        });
        this.facilityDasboardReplica.push(facilityDashbaordValue);
      });
      this.facilityDasboardReplica.forEach(
        (item: any) => {
          let FacilityDashboardAssign: any = [];
          Object.assign(FacilityDashboardAssign, item);
          item.forEach((key: any, index: any) => {
            if (this.filter_option == 'facility') {
              if (key == null && !(item[0] == 'THROMBOLYTIC ADMINISTERED #') ||
                key == null && !(this.reportType == 'monthly')
              ) {
                delete FacilityDashboardAssign[index];
              }
            }
            else {
              if (
                key == null ||
                key == undefined
              ) {
                delete FacilityDashboardAssign[index];
              }
            }
          });
          newArray.push(FacilityDashboardAssign);
        });
      import('xlsx').then((xlsx) => {
        let dataForExcel: any = [];
        let workbook = new Workbook();
        let worksheet = workbook.addWorksheet('Sheet1', { properties: { tabColor: { argb: '36286B' }, outlineLevelRow: 1 } });
        let headers = this.NameListforData(this.fromMonth, this.toMonth);
        newArray.forEach((element: any) => {
          dataForExcel.push(Object.values(element));
        });
        let headerRow = worksheet.addRow(headers);
        worksheet.columns = [{ width: 75 }]; 
        worksheet.columns.forEach(function (column: any, i) {
          if(i!==0)
          {
              let maxLength = 0;
              column["eachCell"]({ includeEmpty: true }, function (cell: any) {
                  let columnLength = cell.value ? cell.value.toString().length : 10;
                  if (columnLength > maxLength ) {
                      maxLength = columnLength;
                  }
              });
              column.width = maxLength < 10 ? 10 : maxLength;
          }
      });

        headerRow.eachCell((cell, number) => {
          cell.fill = {
            type: 'pattern',
            pattern: 'solid',
            fgColor: { argb: '767C88' },
            bgColor: { argb: '' },

          }
          cell.font = {
            bold: true,
            color: { argb: 'FFFFFF' },
            size: 12,
          }
        })
        dataForExcel.forEach((d: any) => {
          let row = worksheet.addRow(d);
        }
        );
        this.excelDownload(workbook, "Facility Dashboard");
        this.exportExcelLoader = false;
      });
    }

    if (this.btnClicked == 2) {
      let activation: any = [];
      let assessment: any = [];
      let thrombolyticDecision: any = [];
      let thrombolyticAdministration: any = [];

      // For Activation
      this.analyzeService._facilityPiFilterObj.RapidiNotificationDataObj.Take = 0;
      this.analyzeService._facilityPiFilterObj.RapidiNotificationDataObj.Skip = 0;
      this.analyzeService.getRapidiNotificationValues(this.RoleName,this.UId,this.analyzeService._facilityPiFilterObj.RapidiNotificationDataObj).subscribe({
        next: (res: any) => {
          if (res) { 
            this.showProgressSpinner = false;
            this.activationTimeList = res.GetACTIrapidinotification.data;
            this.activationTimeList.forEach((item:any)=>{
              if(item.Initial_Assesment != null){
                item.Initial_Assesment = item.Initial_Assesment.split('$');
              }else{
                item.Initial_Assesment = '';
              }
              activation.push({cas_case_number: item.cas_case_number,Facility: item.Facility,DateofConsult: item.DateofConsult,
                IdentificationType: item.IdentificationType,cas_identification_number: item.cas_identification_number,WorkFlowType: item.WorkFlowType,
                ActivationTimeInterval: item.ActivationTimeInterval,Initial_Assesment: item.Initial_Assesment});
            })
// For Assessment
            this.assessmentTimeList = res.GetASTIrapidinotification.data;
            this.assessmentTimeList.forEach((item:any)=>{
              if(item.Initial_Assesment != null){
                item.Initial_Assesment =  item.Initial_Assesment.split('$');
              }else{
                item.Initial_Assesment = '';
              }
              assessment.push({cas_case_number: item.cas_case_number,Facility: item.Facility,DateofConsult: item.DateofConsult,
                IdentificationType: item.IdentificationType,cas_identification_number: item.cas_identification_number,WorkFlowType: item.WorkFlowType,
                AssessmentTimeInterval: item.AssessmentTimeInterval,Initial_Assesment: item.Initial_Assesment});
            })
// For ThrombolyticDecision
            this.thrombolyticDecisionTimeList = res.GetTHDIrapidinotification.data;
            this.thrombolyticDecisionTimeList.forEach((item:any)=>{
              if(item.Initial_Assesment != null){
                item.Initial_Assesment = item.Initial_Assesment.split('$');
              }else{
                item.Initial_Assesment = '';
              }
              thrombolyticDecision.push({cas_case_number: item.cas_case_number,Facility: item.Facility,DateofConsult: item.DateofConsult,
                IdentificationType: item.IdentificationType,cas_identification_number: item.cas_identification_number,WorkFlowType: item.WorkFlowType,
                ThrombolyticDecisionInterval: item.ThrombolyticDecisionInterval,Initial_Assesment: item.Initial_Assesment});
            })
//  For ThrombolyticAdministration
            this.thrombolyticAdministrationTimeList = res.GetTHAIrapidinotification.data;
            this.thrombolyticAdministrationTimeList.forEach((item:any)=>{
              if(item.Initial_Assesment != null){
                item.Initial_Assesment = item.Initial_Assesment.split('$');
              }else{
                item.Initial_Assesment = '';
              }
              thrombolyticAdministration.push({cas_case_number: item.cas_case_number,Facility: item.Facility,DateofConsult: item.DateofConsult,
                IdentificationType: item.IdentificationType,cas_identification_number: item.cas_identification_number,WorkFlowType: item.WorkFlowType,
                ThrombolyticAdministrationInterval: item.ThrombolyticAdministrationInterval,Initial_Assesment: item.Initial_Assesment});
            })
      
            // import('xlsx').then((xlsx) => {
            let activationDataForExcel: any = [];
            let assessmentDataForExcel: any = [];
            let thrymbolyticDecisionDataForExcel: any = [];
            let thrymbolyticAdministrationDataForExcel: any = [];
            let workbook = new Workbook();
            let worksheet1 = workbook.addWorksheet('Activation', { properties: { tabColor: { argb: '36286B' }, outlineLevelRow: 1 } });
            let worksheet2 = workbook.addWorksheet('Assessment', { properties: { tabColor: { argb: '36286B' }, outlineLevelRow: 1 } });
            let worksheet3 = workbook.addWorksheet('Thrombolytic Decision', { properties: { tabColor: { argb: '36286B' }, outlineLevelRow: 1 } });
            let worksheet4 = workbook.addWorksheet('Thrombolytic Administration', { properties: { tabColor: { argb: '36286B' }, outlineLevelRow: 1 } });
      
            activation.forEach((element: any) => {
              activationDataForExcel.push(Object.values(element))
            });
            assessment.forEach((element: any) => {
              assessmentDataForExcel.push(Object.values(element))
            });
            thrombolyticDecision.forEach((element: any) => {
              thrymbolyticDecisionDataForExcel.push(Object.values(element))
            });
            thrombolyticAdministration.forEach((element: any) => {
              thrymbolyticAdministrationDataForExcel.push(Object.values(element))
            });
            worksheet1.columns = [
              { header: 'TeleCare Case #', key: 'cas_case_number', width: 20 },
              { header: 'Facility', key: 'Facility', width: 65 },
              { header: 'Date of Consult', key: 'DateofConsult', width: 25 },
              { header: 'Identification Type', key: 'ActivationTimeInterval', width: 25 },
              { header: 'Identification Number', key: 'IdentificationType', width: 25 },
              { header: 'WorkFlow Type', key: 'WorkFlowType', width: 25 },
              { header: 'Activation Time Interval', key: 'activation time interval', width: 25 },
              { header: 'Initial Assesment', key: 'Initial_Assesment', width: 100 },
            ]
            worksheet2.columns = [
              { header: 'TeleCare Case #', key: 'cas_case_number', width: 20 },
              { header: 'Facility', key: 'facility', width: 65 },
              { header: 'Date of Consult', key: 'date of consult', width: 25 },
              { header: 'Identification Type', key: 'identification type', width: 25 },
              { header: 'Identification Number', key: 'identification number', width: 25 },
              { header: 'WorkFlow Type', key: 'workFlow type', width: 25 },
              { header: 'Assessment Time Interval', key: 'assessment time interval', width: 25 },
              { header: 'Initial Assesment', key: 'initial assesment', width: 100 },
            ]
            worksheet3.columns = [
              { header: 'TeleCare Case #', key: 'cas_case_number', width: 20 },
              { header: 'Facility', key: 'facility', width: 65 },
              { header: 'Date of Consult', key: 'date of consult', width: 25 },
              { header: 'Identification Type', key: 'identification type', width: 25 },
              { header: 'Identification Number', key: 'identification number', width: 25 },
              { header: 'WorkFlow Type', key: 'workFlow type', width: 25 },
              { header: 'Thrombolytic Decision', key: 'thrombolytic decision', width: 25 },
              { header: 'Initial Assesment', key: 'initial assesment', width: 100 },
            ]
            worksheet4.columns = [
              { header: 'TeleCare Case #', key: 'cas_case_number', width: 20 },
              { header: 'Facility', key: 'facility', width: 65 },
              { header: 'Date of Consult', key: 'date of consult', width: 25 },
              { header: 'Identification Type', key: 'identification type', width: 25 },
              { header: 'Identification Number', key: 'identification number', width: 25 },
              { header: 'WorkFlow Type', key: 'workFlow type', width: 25 },
              { header: 'Thrombolytic Administration', key: 'thrombolytic administration', width: 25 },
              { header: 'Initial Assesment', key: 'initial assesment', width: 100 },
            ]
           
            worksheet1.eachRow({ includeEmpty: true }, function(row, rowNumber){
            row.eachCell((cell, number) => {
              cell.fill = {
                type: 'pattern',
                pattern: 'solid',
                fgColor: { argb: '767C88' },
                bgColor: { argb: '' },
      
              }
              cell.font = {
                bold: true,
                color: { argb: 'FFFFFF' },
                size: 12,
              }
            })
          })
          worksheet2.eachRow({ includeEmpty: true }, function(row, rowNumber){
            row.eachCell((cell, number) => {
              cell.fill = {
                type: 'pattern',
                pattern: 'solid',
                fgColor: { argb: '767C88' },
                bgColor: { argb: '' },
      
              }
              cell.font = {
                bold: true,
                color: { argb: 'FFFFFF' },
                size: 12,
              }
            })
          })
          worksheet3.eachRow({ includeEmpty: true }, function(row, rowNumber){
            row.eachCell((cell, number) => {
              cell.fill = {
                type: 'pattern',
                pattern: 'solid',
                fgColor: { argb: '767C88' },
                bgColor: { argb: '' },
      
              }
              cell.font = {
                bold: true,
                color: { argb: 'FFFFFF' },
                size: 12,
              }
            })
          })
          worksheet4.eachRow({ includeEmpty: true }, function(row, rowNumber){
            row.eachCell((cell, number) => {
              cell.fill = {
                type: 'pattern',
                pattern: 'solid',
                fgColor: { argb: '767C88' },
                bgColor: { argb: '' },
      
              }
              cell.font = {
                bold: true,
                color: { argb: 'FFFFFF' },
                size: 12,
              }
            })
          })
            activationDataForExcel.forEach((d: any) => {
              let row = worksheet1.addRow(d);
            })
            assessmentDataForExcel.forEach((d: any) => {
              let row = worksheet2.addRow(d);
            })
            thrymbolyticDecisionDataForExcel.forEach((d: any) => {
              let row = worksheet3.addRow(d);
            })
            thrymbolyticAdministrationDataForExcel.forEach((d: any) => {
              let row = worksheet4.addRow(d);
            })
            this.excelDownload(workbook, "RAPIDI Case Reports");
            this.exportExcelLoader = false;
          }
        },
        error: (err: any) => { },
      });
      
    }

    if (this.btnClicked == 3) {
      this.analyzeService._facilityPiFilterObj.TpaCaseAnalysisDataObj.Take = 0;
      this.analyzeService._facilityPiFilterObj.TpaCaseAnalysisDataObj.Skip = 0;
      this.analyzeService.getTPAAnalysisValues(this.RoleName,this.UId,this.analyzeService._facilityPiFilterObj.TpaCaseAnalysisDataObj).subscribe({
        next: (res: any) => {
          if (res) { 
            this.tPACaseAnalysisList = res.data;
            this.tPACaseAnalysisList.forEach(
              (item: any) => {
                let TpaCaseAssign: any = [];
                Object.assign(TpaCaseAssign, item);
                let keys = Object.keys(item);
                keys.forEach((key: any) => {
                  if (
                    key == 'fac_key' ||
                    key == 'id' ||
                    key == 'Case_Key' ||
                    key == 'RootCauseCount' ||
                    key == 'RootId' ||
                    key == 'FacilityID' ||
                    key == 'PatientName' ||
                    key == 'RootCause' ||
                    key == 'RootCauseGrp' ||
                    key == 'StartTime'
                  ) {
                    delete TpaCaseAssign[key];
                  }
                });
      
                newArray.push(TpaCaseAssign);
              }
            );
            let dataForExcel: any = [];
            let workbook = new Workbook();
            let worksheet = workbook.addWorksheet('Sheet1', { properties: { tabColor: { argb: '36286B' }, outlineLevelRow: 1 } });
            worksheet.columns = [
              { header: 'Facility', key: 'facility', width: 65 },
              { header: 'TeleCare Case #', key: 'cas_case_number', width: 20 },
              { header: 'Date', key: 'date', width: 20 },
              { header: 'Process (EMS / WI/ IP / ED)', key: 'process (ems / wi/ ip / ed)', width: 30 },
              { header: 'DTN (Min)', key: 'dtn (min)', width: 30 },
              { header: 'Thrombolytic Delay Notes', key: 'thrombolytic delay notes', width: 40},
              { header: 'QPS Analysis', key: 'qps analysis', width: 40},
              { header: 'Medical Director Analysis', key: 'medical director analysis', width: 40},
            ]
            newArray.forEach((element: any) => {
              dataForExcel.push(Object.values(element))
            });
      
            worksheet.eachRow({ includeEmpty: true }, function (row, rowNumber) {
              row.eachCell((cell, number) => {
                cell.fill = {
                  type: 'pattern',
                  pattern: 'solid',
                  fgColor: { argb: '767C88' },
                  bgColor: { argb: '' },
      
                }
                cell.font = {
                  bold: true,
                  color: { argb: 'FFFFFF' },
                  size: 12,
                }
                cell.alignment = {
                  horizontal: 'left',
                }
              })
            })
            dataForExcel.forEach((d: any) => {
              let row = worksheet.addRow(d);
              row.getCell('thrombolytic delay notes').alignment = { vertical: 'top', horizontal: 'left', wrapText: true };
              row.getCell('qps analysis').alignment = { vertical: 'top', horizontal: 'left', wrapText: true };
              row.getCell('medical director analysis').alignment = { vertical: 'top', horizontal: 'left', wrapText: true };
            })
            this.excelDownload(workbook, "Thrombolytic Case Analysis");
            this.exportExcelLoader = false;
          }
        },
        error: (err: any) => { },
      });
      
    }

    if (this.btnClicked == 4) {
      let rootCauseTrends: any = [];
      let getCaseReviewTrends: any = [];
      this.analyzeService._facilityPiRecord.rootCauseTrendsList.GetRootCauseTrends.data.forEach(
        (item: any) => {
          let rootCauseAssign: any = [];
          Object.assign(rootCauseAssign, item);
          let keys = Object.keys(item);
          keys.forEach((key: any) => {
            if (
              rootCauseAssign[key] == null ||
              rootCauseAssign[key] == undefined ||
              key == 'fac_key' ||
              key == 'id'
            ) {
              delete rootCauseAssign[key];
            }
          });
          rootCauseTrends.push(rootCauseAssign);
        }
      );
      // For GetCaseReviewTrends
      this.analyzeService._facilityPiRecord.rootCauseTrendsList.GetCaseReviewTrends.data.forEach(
        (item: any) => {
          let CaseReviewAssign: any = [];
          Object.assign(CaseReviewAssign, item);
          let keys = Object.keys(item);
          keys.forEach((key: any) => {
            if (
              CaseReviewAssign[key] == null ||
              CaseReviewAssign[key] == undefined ||
              key == 'fac_key' ||
              key == 'id'
            ) {
              delete CaseReviewAssign[key];
            }
          });
          getCaseReviewTrends.push(CaseReviewAssign);
        }
      );

      let workbook = new Workbook();
      let rootCausedataForExcel: any = [];
      let getCaseReviewdataForExcel: any = [];
      let worksheet1 = workbook.addWorksheet('RootCause', { properties: { tabColor: { argb: '36286B' }, outlineLevelRow: 1 } });
      let worksheet2 = workbook.addWorksheet('CaseReview', { properties: { tabColor: { argb: '36286B' }, outlineLevelRow: 1 } });
      worksheet1.columns = [
        { header: 'Root Cause Type', key: 'root cause type', width: 30 },
        { header: 'Root Cause', key: 'root cause', width: 65 },
        { header: 'Root Cause Count', key: 'root cause count', width: 20 },
      ]
      worksheet2.columns = [
        { header: 'Perfomance Metric Outliers', key: 'perfomance metric outliers', width: 50 },
        { header: 'Number of Times', key: 'number of times', width: 20 },
      ]

      rootCauseTrends.forEach((element: any) => {
        rootCausedataForExcel.push(Object.values(element))
      });
      getCaseReviewTrends.forEach((element: any) => {
        getCaseReviewdataForExcel.push(Object.values(element))
      });

      worksheet1.eachRow({ includeEmpty: true }, function(row, rowNumber){
      row.eachCell((cell, number) => {
        cell.fill = {
          type: 'pattern',
          pattern: 'solid',
          fgColor: { argb: '767C88' },
          bgColor: { argb: '' },

        }
        cell.font = {
          bold: true,
          color: { argb: 'FFFFFF' },
          size: 12,
        }
      })
    })
    worksheet2.eachRow({ includeEmpty: true }, function(row, rowNumber){
      row.eachCell((cell, number) => {
        cell.fill = {
          type: 'pattern',
          pattern: 'solid',
          fgColor: { argb: '767C88' },
          bgColor: { argb: '' },

        }
        cell.font = {
          bold: true,
          color: { argb: 'FFFFFF' },
          size: 12,
        }
      })
    })
      rootCausedataForExcel.forEach((d: any) => {
        let row = worksheet1.addRow(d);
      })
      getCaseReviewdataForExcel.forEach((d: any) => {
        let row = worksheet2.addRow(d);
      })
      this.excelDownload(workbook, "PI Trends");
      this.exportExcelLoader = false;
    }

    if(this.btnClicked == 5){
      this.analyzeService._facilityPiFilterObj.CounterMeasuresDataObj.Take = 0;
      this.analyzeService._facilityPiFilterObj.CounterMeasuresDataObj.Skip = 0;
      this.analyzeService.GetCounterMeasures(this.RoleName,this.UId,this.analyzeService._facilityPiFilterObj.CounterMeasuresDataObj).subscribe({
        next: (res: any) => {
          this.counterMeasuresData = res.data;
          this.proposed_date_array = [];
          this.counterMeasuresData.forEach((c:any,indx:any)=>{
            if(c._objCounterMeasures.length > 0){
              c._objCounterMeasures.forEach((o:any)=>{
                if(o.rca_proposed_due_date != null || o.rca_proposed_due_date != ""){
                  const formatedDate = new Date(o.rca_proposed_due_date)
                  o.rca_proposed_due_date = this.datePipe.transform(formatedDate, 'dd/MM/yyyy');
                  let currentDate:any = this.datePipe.transform(new Date(), 'dd/MM/yyyy');
                  
                  if( o.rca_completed_date == null && o.rca_proposed_due_date < currentDate){
                    this.proposed_date_array.push({date:o.rca_proposed_due_date,rootCause:o.rca_root_cause});
                  }
                }
              })
            
            let fromIndex:any;
            let element: any;
            let counterMeasuresList: any;
            if(this.proposed_date_array.length > 0){
                const sortedActivities = this.proposed_date_array.sort((a:any, b:any) => new Date(b.date).getTime() - new Date(a.date).getTime());
                sortedActivities.forEach((item:any)=>{
                  fromIndex= c._objCounterMeasures.findIndex((num:any)=>num.rca_proposed_due_date === item.date && num.rca_completed_date == null && num.rca_root_cause == item.rootCause);
  
                  if(fromIndex != 0 && fromIndex != -1){
                    element = c._objCounterMeasures.splice(fromIndex, 1)[0];
                    element.status = true;
                    c._objCounterMeasures.unshift(element);
                  }
                  if(fromIndex == 0){
                    c._objCounterMeasures[0].status = true;
                  }
                });
                
                counterMeasuresList = this.counterMeasuresData.splice(indx, 1)[0];
                this.counterMeasuresData.unshift(counterMeasuresList);
                this.proposed_date_array = [];
            }
              }
          })
          
          this.counterMeasuresData = this.counterMeasuresData.sort((a:any, b:any) =>  !a._objCounterMeasures[0]?.rca_proposed_due_date ? 1 : !b._objCounterMeasures[0]?.rca_proposed_due_date ? 1 :  Number(new Date(a._objCounterMeasures[0]?.rca_proposed_due_date)) - Number(new Date(b._objCounterMeasures[0]?.rca_proposed_due_date)))
          
          this.counterMeasuresData.forEach(
            (item: any) => {
              if(item._objCounterMeasures.length > 0){
                item._objCounterMeasures.forEach((val: any) => {
                  val.rca_completed_date = this.datePipe.transform(val.rca_completed_date, 'dd/MM/yyyy');
                  newArray.push({casenumber: item.casenumber,facility: item.facility,PatientName: item.PatientName,RootCause: val.RootCause,
                    rca_proposed_countermeasure: val.rca_proposed_countermeasure,rca_responsible_party: val.rca_responsible_party,
                    rca_proposed_due_date: val.rca_proposed_due_date,rca_completed_date: val.rca_completed_date})
                })
              }else{
                newArray.push({casenumber: item.casenumber,facility: item.facility,PatientName: item.PatientName})
              }
            }
          );
          let dataForExcel: any = [];
          let workbook = new Workbook();
          let worksheet = workbook.addWorksheet('Sheet1', { properties: { tabColor: { argb: '36286B' }, outlineLevelRow: 1 } });
          worksheet.columns = [
            { header: 'Case Number', key: 'casenumber', width: 18 },
            { header: 'Facility', key: 'facility', width: 60 },
            { header: 'Patient Name', key: 'PatientName', width: 25 },
            { header: 'Root Cause', key: 'RootCause', width: 100 },
            { header: 'Countermeasure(S)', key: 'rca_proposed_countermeasure', width: 20 },
            { header: 'Responsible Party', key: 'rca_responsible_party', width: 20 },
            { header: 'Proposed Due Date', key: 'rca_proposed_due_date', width: 20 },
            { header: 'Completed Date', key: 'rca_completed_date', width: 20 }
          ]
          newArray.forEach((element: any) => {
            dataForExcel.push(Object.values(element))
          });
          worksheet.eachRow({ includeEmpty: true }, function (row, rowNumber) {
            row.eachCell((cell, number) => {
              cell.fill = {
                type: 'pattern',
                pattern: 'solid',
                fgColor: { argb: '767C88' },
                bgColor: { argb: '' },
    
              }
              cell.font = {
                bold: true,
                color: { argb: 'FFFFFF' },
                size: 12,
              }
            })
          })
          dataForExcel.forEach((d: any) => {
            let row = worksheet.addRow(d);
          })
          this.excelDownload(workbook, "CounterMeasure");
          this.exportExcelLoader = false;
        },
      });
      
    }

    if (this.btnClicked == 6) {
      this.analyzeService._facilityPiRecord.VolumetricsRecord.forEach(
        (item: any) => {
          let volumetricAssign: any = [];
          Object.assign(volumetricAssign, item);
          let keys = Object.keys(item);
          keys.forEach((key: any) => {
            if (
              volumetricAssign[key] == null ||
              volumetricAssign[key] == undefined ||
              key == 'fac_key' ||
              key == 'id'
            ) {
              delete volumetricAssign[key];
            }
          });
          newArray.push(volumetricAssign);
        }
      );
      let dataForExcel: any = [];
      let workbook = new Workbook();
      let worksheet = workbook.addWorksheet('Sheet1', { properties: { tabColor: { argb: '36286B' }, outlineLevelRow: 1 } });
      worksheet.columns = [
        { header: 'Date', key: 'date', width: 20 },
        { header: 'Stroke Alert', key: 'stroke alert', width: 15 },
        { header: 'STAT', key: 'proportion ems', width: 15 },
        { header: 'New', key: 'new', width: 15 },
        { header: 'Folow Up', key: 'folow up', width: 15 },
        { header: 'EEG', key: 'eeg', width: 15 },
      ]
      newArray.forEach((element: any) => {
        dataForExcel.push(Object.values(element))
      });
      worksheet.eachRow({ includeEmpty: true }, function (row, rowNumber) {
        row.eachCell((cell, number) => {
          cell.fill = {
            type: 'pattern',
            pattern: 'solid',
            fgColor: { argb: '767C88' },
            bgColor: { argb: '' },

          }
          cell.font = {
            bold: true,
            color: { argb: 'FFFFFF' },
            size: 12,
          }
          cell.alignment = {
            horizontal: typeof cell.value === 'number' ? 'left' : 'left',
          }
          if (typeof cell.value === 'number') {
            cell.numFmt = '#,##0.00;[Red]-#,##0.00'
          }
        })
      })
      dataForExcel.forEach((d: any) => {
        let row = worksheet.addRow(d);
      })
      this.excelDownload(workbook, "Volumetrics");
      this.exportExcelLoader = false;
    }

    if (this.btnClicked == 7) {
      this.analyzeService._facilityPiRecord.StrokeAlertCasesRecord.forEach(
        (item: any) => {
          let strokeAlertAssign: any = [];
          Object.assign(strokeAlertAssign, item);
          let keys = Object.keys(item);
          keys.forEach((key: any) => {
            if (
              strokeAlertAssign[key] == null ||
              strokeAlertAssign[key] == undefined ||
              key == 'fac_key' ||
              key == 'id'
            ) {
              delete strokeAlertAssign[key];
            }
          });

          newArray.push(strokeAlertAssign);
        }
      );
      let dataForExcel: any = [];
      let workbook = new Workbook();
      let worksheet = workbook.addWorksheet('Sheet1', { properties: { tabColor: { argb: '36286B' }, outlineLevelRow: 1 } });
      worksheet.columns = [
        { header: 'Date', key: 'date', width: 20 },
        { header: 'EMS Arrival #', key: 'ems arrival #', width: 15 },
        { header: 'Proportion EMS', key: 'proportion ems', width: 20 },
        { header: 'PV/Walk In Arrival #', key: 'pv/walk in arrival #', width: 25 },
        { header: 'Proportion PV/ Walk In', key: 'proportion pv/ walk in', width: 25 },
        { header: 'Inpatient #', key: 'inpatient #', width: 15 },
        { header: 'Proportion Inpatient', key: 'proportion inpatient', width: 25 },
        { header: 'ED Onset', key: 'ed onset', width: 15 },
        { header: 'Proportion ED Onset', key: 'proportion ed onset', width: 23 },
        { header: 'Audio Consult #', key: 'price', width: 20 },
        { header: 'Proportion Audio Consult', key: 'price', width: 30 }
      ]
      worksheet.eachRow({ includeEmpty: true }, function (row, rowNumber) {
        row.eachCell((cell, number) => {
          cell.fill = {
            type: 'pattern',
            pattern: 'solid',
            fgColor: { argb: '767C88' },
            bgColor: { argb: '' },

          }
          cell.font = {
            bold: true,
            color: { argb: 'FFFFFF' },
            size: 12,
          }
        })
      })
      newArray.forEach((element: any) => {
        dataForExcel.push(Object.values(element))
      });

      dataForExcel.forEach((d: any) => {
        let row = worksheet.addRow(d);
      })
      this.excelDownload(workbook, "Stroke Alert Cases");
      this.exportExcelLoader = false;
    }
    
  }

  nullValues() {
    this.Facilities = [];
    this.System = [];
    this.Regional = [];
    this.States = [];
    this.QPS = [];
  }

  rapidiTabBool: boolean = false;
  filterSelection() {
    if (
      this.facilitySelectedTab == 'RAPIDi Notification' ||
      this.facilitySelectedTab == 'Counter Measures' ||
      this.facilitySelectedTab == 'Volumetrics' ||
      this.facilitySelectedTab == 'Stroke Alert Cases' ||
      this.facilitySelectedTab == 'TPA Case Analysis'
    ) {
      this.selectedFacilitybtnBool = true;
      this.rAPIDiNotificationBool = true;
      this.tPACaseAnalysisBool = false;
      this.reportTypeBool = true;
      this.fromDaysToDaysBool = false;
      this.selectWeekBool = false;
      this.pITrendsBool = false;
      // this.spokeSiteBool = false;
      if (this.event == 'system' || this.event == 'regional') {
        this.spokeSiteBool = true;
      }
      this.excel_chartDisabe.facility_charts_Show = false;
    }
    if (this.facilitySelectedTab == 'Facility Dashboard') {
      this.excelFileByTab = 1;
      this.btnClicked = 1;
      this.excel_chartDisabe.pi_chart_show = false;
      this.selectedFacilitybtnBool = true;
      this.workFlowPiTrendTypeBool = false;
      this.pre_ArrivalBool = false;
      this.rAPIDiNotificationBool = false;
      this.tPACaseAnalysisBool = false;
      this.reportTypeBool = false;
      this.pITrendsBool = false;
      this.workFlowRapidTypeBool = false;
      this.excel_chartDisabe.facility_charts_Show = true;
      if (this.facility_Pi_Show.fac_Dashboard_Show == false) {
        this.excel_chartDisabe.excel_show = true;
      }
      /* in case facility dashboard daily or weekly date select */
      if(this.tempSelectReportOption == 'daily' || this.tempSelectReportOption == 'weekly'){
        this.selctReportOption = this.tempSelectReportOption;
      }

      if (this.selctReportOption == 'daily') {
        this.fromDaysToDaysBool = true;
        this.selectWeekBool = false;
        this.monthBool = false;
      } else if (this.selctReportOption == 'weekly') {
        this.fromDaysToDaysBool = false;
        this.selectWeekBool = true;
        this.monthBool = false;
      } else if (this.selctReportOption == 'monthly') {
        this.fromDaysToDaysBool = false;
        this.selectWeekBool = false;
        this.monthBool = true;
      } else if (this.selctReportOption == 'cumulative') {
        this.fromDaysToDaysBool = false;
        this.selectWeekBool = false;
        this.monthBool = true;
      }else{
        this.fromDaysToDaysBool = false;
        this.selectWeekBool = false;
        this.monthBool = false;
      }

      if (this.event == 'system' || this.event == 'regional') {
        this.spokeSiteBool = true;
      }

      if (this.analyzeService._facilityPiFilterObj.FacilityDashboardDataObj != undefined) {
        this.excel_chartDisabe.value = false;
      }
      this.selctReportOption = '';

      switch(this.reportType){
        case 'daily': this.fromDaysToDaysBool = true;break;
        case 'weekly': this.selectWeekBool = true;break;
        case 'monthly': this.monthBool = true;break;
        case 'cumulative': this.monthBool = true;break;
      }
    }
    if (this.facilitySelectedTab == 'TPA Case Analysis') {
      this.btnClicked = 3;
      this.selectedFacilitybtnBool = true;
      // this.spokeSiteBool = false;
      this.workFlowPiTrendTypeBool = false;
      this.pre_ArrivalBool = false;
      this.tPACaseAnalysisBool = true;
      this.pITrendsBool = false;
      this.workFlowRapidTypeBool = false;
      this.reportTypeBool = true;
      this.fromDaysToDaysBool = false;
      this.excel_chartDisabe.facility_charts_Show = false;
      this.excel_chartDisabe.pi_chart_show = false;
      if (this.facility_Pi_Show.thrym_Cas_Ana_Show == false) {
        this.excel_chartDisabe.excel_show = true;
        this.excel_chartDisabe.value = true;
      }
      if (this.analyzeService._facilityPiFilterObj.TpaCaseAnalysisDataObj != undefined) {
        this.excel_chartDisabe.value = false;
      }
      if(this.tempSelectReportOption != ""){
        this.analyzeService._reportType = this.tempSelectReportOption;
      }
      if(this.tempSelectReportOption != ""){
        this.analyzeService._facilitySelectedTab = this.facilitySelectedTab;
      }

      switch(this.reportType){
        case 'daily': this.fromDaysToDaysBool = true;break;
        case 'weekly': this.selectWeekBool = true;break;
        case 'monthly': this.monthBool = true;break;
        case 'cumulative': this.monthBool = true;break;
      }
    }
    if (this.facilitySelectedTab == 'PI Trends') {
      this.btnClicked = 4;
      this.selectedFacilitybtnBool = true;
      // this.spokeSiteBool = false;
      this.workFlowPiTrendTypeBool = true;
      this.pre_ArrivalBool = false;
      this.pITrendsBool = true;
      this.workFlowRapidTypeBool = false;
      this.fromDaysToDaysBool = false;
      this.selectWeekBool = false;
      this.reportTypeBool = true;
      this.excel_chartDisabe.facility_charts_Show = false;
      this.excel_chartDisabe.excel_show = true;
      this.excel_chartDisabe.pi_chart_show = false;
      if (this.facility_Pi_Show.pi_Trend_Show == false) {
        this.excel_chartDisabe.value = true;
      }

      if (this.analyzeService._facilityPiFilterObj.PiTrendsDataObj != undefined) {
        this.excel_chartDisabe.value = false;
      }
      if (this.event == 'system' || this.event == 'regional') {
        this.spokeSiteBool = true;
      }
      switch(this.reportType){
        case 'daily': this.fromDaysToDaysBool = true;break;
        case 'weekly': this.selectWeekBool = true;break;
        case 'monthly': this.monthBool = true;break;
        case 'cumulative': this.monthBool = true;break;
      }
    }
    if (this.facilitySelectedTab == 'Counter Measures') {
      this.btnClicked = 5;
      this.workFlowPiTrendTypeBool = false;
      this.pre_ArrivalBool = false;
      this.excel_chartDisabe.excel_show = true;
      this.excel_chartDisabe.pi_chart_show = false;
      this.workFlowRapidTypeBool = false;

      if (this.analyzeService._facilityPiFilterObj.CounterMeasuresDataObj != undefined) {
        this.excel_chartDisabe.value = false;
      }
      if(this.tempSelectReportOption != ""){
        this.analyzeService._reportType = this.tempSelectReportOption;
      }
      if(this.tempSelectReportOption != ""){
        this.analyzeService._facilitySelectedTab = this.facilitySelectedTab;
      }
      switch(this.reportType){
        case 'daily': this.fromDaysToDaysBool = true;break;
        case 'weekly': this.selectWeekBool = true;break;
        case 'monthly': this.monthBool = true;break;
        case 'cumulative': this.monthBool = true;break;
      }
    }
    if (this.facilitySelectedTab == 'RAPIDi Notification') {
      this.btnClicked = 2;
      this.workFlowPiTrendTypeBool = true;
      this.excel_chartDisabe.excel_show = true;
      this.workFlowRapidTypeBool = true;
      this.pre_ArrivalBool = true;
      this.excel_chartDisabe.pi_chart_show = false;
      if (this.facility_Pi_Show.rapidi_Noti_Show == false) {
        this.excel_chartDisabe.value = true;
      }
      if (this.analyzeService._facilityPiRecord.getRAPIDNotificationValuesList != undefined) {
        this.analyzeService._facilityPiFilterObj.RapidiNotificationDataObj.showChartBool = false;
        this.excel_chartDisabe.value = false;
      }
      
      if(this.tempSelectReportOption != ""){
        this.analyzeService._reportType = this.tempSelectReportOption;
      }
      if(this.tempSelectReportOption != ""){
        this.analyzeService._facilitySelectedTab = this.facilitySelectedTab;
      }
      switch(this.reportType){
        case 'daily': this.fromDaysToDaysBool = true;break;
        case 'weekly': this.selectWeekBool = true;break;
        case 'monthly': this.monthBool = true;break;
        case 'cumulative': this.monthBool = true;break;
      }
    }
    if (this.facilitySelectedTab == 'Volumetrics') {
      this.btnClicked = 6;
      this.piCharVisibility = true;
      this.excel_chartDisabe.pi_chart_show = true;
      this.workFlowPiTrendTypeBool = false;
      this.excel_chartDisabe.excel_show = true;
      this.workFlowRapidTypeBool = false;
      this.pre_ArrivalBool = false;
      if (this.facility_Pi_Show.volumetric_Show == false) {
        this.excel_chartDisabe.value = true;
      }
      if (this.analyzeService._facilityPiFilterObj.VolumetricsDataObj != undefined) {
        this.excel_chartDisabe.value = false;
      }
      switch(this.reportType){
        case 'daily': this.fromDaysToDaysBool = true;break;
        case 'weekly': this.selectWeekBool = true;break;
        case 'monthly': this.monthBool = true;break;
        case 'cumulative': this.monthBool = true;break;
      }
    }
    if (this.facilitySelectedTab == 'Stroke Alert Cases') {
      this.btnClicked = 7;
      this.piCharVisibility = false;
      this.excel_chartDisabe.pi_chart_show = true;
      this.workFlowPiTrendTypeBool = false;
      this.excel_chartDisabe.excel_show = true;
      this.workFlowRapidTypeBool = false;
      this.pre_ArrivalBool = false;
      if (this.facility_Pi_Show.strokeAlert_Cases_Show == false) {
        this.excel_chartDisabe.value = true;
      }

      if (this.analyzeService._facilityPiFilterObj.StrokeAlertCasesDataObj != undefined) {
        this.excel_chartDisabe.value = false;
      }
      switch(this.reportType){
        case 'daily': this.fromDaysToDaysBool = true;break;
        case 'weekly': this.selectWeekBool = true;break;
        case 'monthly': this.monthBool = true;break;
        case 'cumulative': this.monthBool = true;break;
      }
    }
  }

  exportPdf(): void {
    this.exportPdfFacilityDashboardLoader = true;

    drawDOM(document.getElementById("htmlData") as HTMLElement, {
      paperSize: "A4",
      scale: 0.71,
      landscape: true,
      margin: { left: "0.5cm", top: "1cm", right: "0cm", bottom: "1cm" },
      forcePageBreak: '.QMSALLCHARTS',
    }).then((group: Group) => {
      return exportPDF(group);
    })
      .then((dataUri) => {
        saveAs(dataUri, "FacilityDashboardCharts.pdf");
        this.exportPdfFacilityDashboardLoader = false;
      });
  }

  calculateRotation() {
    let numLabels = this.doortostartMeanChart.length;
    
    let rotation = 0;
    if (numLabels > 12 && this.screenWidth < 1300) {
      rotation = -50;
    }else if (numLabels > 12 && this.screenWidth > 1300) {
      rotation = -30;
    }else{
      rotation = 0
    }
    return rotation;
  }

  calculateLengthForMarginLabel(){
    let numLabels = this.doortostartMeanChart.length;
    let margin = 0;
    if (numLabels > 12 && this.screenWidth > 1300) {
      margin = 35;
    }else if(numLabels > 12 && this.screenWidth < 1300){
      margin = 20
    }else if (numLabels <= 12 && this.screenWidth > 1300) {
      margin = 25;
    }else if(numLabels >= 12 && this.screenWidth < 1300){
      margin = 15
    }else{
      margin = 30
    }
    return margin;
}
onContextMenu(event:any){
  event.preventDefault();
}

  formatYAxisLabel(val: AxisLabelContentArgs): any {
      return ((new Date(val.value)).getHours() * 60 + (new Date(val.value)).getMinutes() + ':' + (new Date(val.value)).getSeconds());
    }

  ngOnDestroy() {
    this.analyzeService._facilityPiComponent = {};
    this.analyzeService._facilityPiFilterObj = {};
    this.analyzeService._facilityPiRecord = {};
  }

}